import React from "react";
import {
  createBrowserRouter,
  redirect,
  LoaderFunctionArgs,
  RouteObject,
} from "react-router";
import {
  LoginPage,
  NotFoundPage,
  HomePage,
  ChangePasswordPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  VerifyEmailPage,
} from "../common/pages";

import {
  UserCreatePage,
  UserViewPage,
  UserListPage,
  UserUpdatePage,
  SiteUserCreatePage,
  SiteUserViewPage,
  SiteUserListPage,
  SiteUserUpdatePage,
  RoleCreatePage,
  RoleViewPage,
  RoleListPage,
  RoleUpdatePage,
  PermissionCreatePage,
  PermissionViewPage,
  PermissionListPage,
  PermissionUpdatePage,
  TenantCreatePage,
  TenantViewPage,
  TenantListPage,
  TenantUpdatePage,
  TenantProfileCreatePage,
  TenantProfileViewPage,
  TenantProfileListPage,
  TenantProfileUpdatePage,
  VatStatusCreatePage,
  VatStatusViewPage,
  VatStatusListPage,
  VatStatusUpdatePage,
  GrossReceiptsStatusCreatePage,
  GrossReceiptsStatusViewPage,
  GrossReceiptsStatusListPage,
  GrossReceiptsStatusUpdatePage,
  TenantTypeCreatePage,
  TenantTypeViewPage,
  TenantTypeListPage,
  TenantTypeUpdatePage,
  TenantStatusCreatePage,
  TenantStatusViewPage,
  TenantStatusListPage,
  TenantStatusUpdatePage,
  CurrencyCreatePage,
  CurrencyViewPage,
  CurrencyListPage,
  CurrencyUpdatePage,
  TenantPlanCreatePage,
  TenantPlanViewPage,
  TenantPlanListPage,
  TenantPlanUpdatePage,
  CountryCreatePage,
  CountryViewPage,
  CountryListPage,
  CountryUpdatePage,
  ProvinceStateCreatePage,
  ProvinceStateViewPage,
  ProvinceStateListPage,
  ProvinceStateUpdatePage,
  CreditTierCreatePage,
  CreditTierViewPage,
  CreditTierListPage,
  CreditTierUpdatePage,
  CreditAccountViewPage,
  CreditAccountListPage,
  CreditAccountUpdatePage,
  CreditPurchaseCreatePage,
  CreditPurchaseViewPage,
  CreditPurchaseListPage,
  MyCreditPurchasesViewPage,
  MyCreditPurchasesListPage,
  CreditMovementViewPage,
  CreditMovementListPage,
  WorkerEventViewPage,
  WorkerEventListPage,
  SimulationSessionViewPage,
  SimulationSessionListPage,
  SnapshotOverrideCreatePage,
  SnapshotOverrideViewPage,
  SnapshotOverrideListPage,
  SnapshotOverrideUpdatePage,
  BotRunViewPage,
  BotRunListPage,
  BotPhaseViewPage,
  BotPhaseListPage,
  BotStepViewPage,
  BotStepListPage,
  BotErrorViewPage,
  BotErrorListPage,
  SatelliteMachineCreatePage,
  SatelliteMachineViewPage,
  SatelliteMachineListPage,
  SatelliteMachineUpdatePage,
  SatelliteTaskViewPage,
  SatelliteTaskListPage,
  SatelliteHeartbeatViewPage,
  SatelliteHeartbeatListPage,
  DashboardWidgetViewPage,
  DashboardWidgetListPage,
  TenantWidgetAccessCreatePage,
  TenantWidgetAccessViewPage,
  TenantWidgetAccessListPage,
  TenantWidgetAccessUpdatePage,
  UserWidgetConfigCreatePage,
  UserWidgetConfigViewPage,
  UserWidgetConfigListPage,
  UserWidgetConfigUpdatePage,
  DashboardLayoutTemplateCreatePage,
  DashboardLayoutTemplateViewPage,
  DashboardLayoutTemplateListPage,
  DashboardLayoutTemplateUpdatePage,
  ReportCreatePage,
  ReportViewPage,
  ReportListPage,
  ReportUpdatePage,
  ReportTypeCreatePage,
  ReportTypeViewPage,
  ReportTypeListPage,
  ReportTypeUpdatePage,
  UserNotificationViewPage,
  UserNotificationListPage,
  UserNotificationPreferenceCreatePage,
  UserNotificationPreferenceViewPage,
  UserNotificationPreferenceListPage,
  UserNotificationPreferenceUpdatePage,
  AlertRuleCreatePage,
  AlertRuleViewPage,
  AlertRuleListPage,
  AlertRuleUpdatePage,
  AlertSubscriptionCreatePage,
  AlertSubscriptionViewPage,
  AlertSubscriptionListPage,
  AlertSubscriptionUpdatePage,
  EmailVerificationCreatePage,
  EmailVerificationViewPage,
  EmailVerificationListPage,
  EmailVerificationUpdatePage,
  ShowcaseWorkflowStateCreatePage,
  ShowcaseWorkflowStateViewPage,
  ShowcaseWorkflowStateListPage,
  ShowcaseWorkflowStateUpdatePage,
  ShowcaseCategoryCreatePage,
  ShowcaseCategoryViewPage,
  ShowcaseCategoryListPage,
  ShowcaseCategoryUpdatePage,
  ShowcaseLineViewPage,
  ShowcaseLineListPage,
  DesignShowcaseCreatePage,
  DesignShowcaseViewPage,
  DesignShowcaseListPage,
  DesignShowcaseUpdatePage,
  ThemeViewPage,
  ThemeListPage,
  AuthorComposerCreatePage,
  AuthorComposerViewPage,
  AuthorComposerListPage,
  AuthorComposerUpdatePage,
  AuthorComposerPublicCreatePage,
  AuthorComposerPublicViewPage,
  AuthorComposerPublicListPage,
  AuthorComposerPublicUpdatePage,
  CollectiveManagementSocietyCreatePage,
  CollectiveManagementSocietyViewPage,
  CollectiveManagementSocietyListPage,
  CollectiveManagementSocietyUpdatePage,
  AuthorCollectingSocietyViewPage,
  AuthorCollectingSocietyListPage,
  PublisherCreatePage,
  PublisherViewPage,
  PublisherListPage,
  PublisherUpdatePage,
  AuthorPublisherViewPage,
  AuthorPublisherListPage,
  WorkAuthorPublisherViewPage,
  WorkAuthorPublisherListPage,
  PublisherCollectingSocietyViewPage,
  PublisherCollectingSocietyListPage,
  PublisherRepresentativeViewPage,
  PublisherRepresentativeListPage,
  EditionTypeCreatePage,
  EditionTypeViewPage,
  EditionTypeListPage,
  EditionTypeUpdatePage,
  MusicalWorkCreatePage,
  MusicalWorkViewPage,
  MusicalWorkListPage,
  MusicalWorkUpdatePage,
  PhonogramViewPage,
  PhonogramListPage,
  TerritoryCreatePage,
  TerritoryViewPage,
  TerritoryListPage,
  TerritoryUpdatePage,
  MusicalWorkLinkViewPage,
  MusicalWorkLinkListPage,
  PlatformCreatePage,
  PlatformViewPage,
  PlatformListPage,
  PlatformUpdatePage,
  PlatformLinkTypeCreatePage,
  PlatformLinkTypeViewPage,
  PlatformLinkTypeListPage,
  PlatformLinkTypeUpdatePage,
  WorkAuthorViewPage,
  WorkAuthorListPage,
  EditionCreatePage,
  EditionViewPage,
  EditionListPage,
  EditionUpdatePage,
  SignedEditionViewPage,
  SignedEditionListPage,
  EditionContractPublisherViewPage,
  EditionContractPublisherListPage,
  EditionDocumentationViewPage,
  EditionDocumentationListPage,
  SignedContractViewPage,
  SignedContractListPage,
  EditionDocumentTypeCreatePage,
  EditionDocumentTypeViewPage,
  EditionDocumentTypeListPage,
  EditionDocumentTypeUpdatePage,
  AssociatedDocumentEditionViewPage,
  AssociatedDocumentEditionListPage,
  AssociatedDocumentSignedEditionViewPage,
  AssociatedDocumentSignedEditionListPage,
  SignedEditionBlockchainCertViewPage,
  SignedEditionBlockchainCertListPage,
  UserAttachmentEditionViewPage,
  UserAttachmentEditionListPage,
  InterpreterCreatePage,
  InterpreterViewPage,
  InterpreterListPage,
  InterpreterUpdatePage,
  MusicalGenreCreatePage,
  MusicalGenreViewPage,
  MusicalGenreListPage,
  MusicalGenreUpdatePage,
  ContractObservationCreatePage,
  ContractObservationViewPage,
  ContractObservationListPage,
  ContractObservationUpdatePage,
  PaymentReceiptTypeCreatePage,
  PaymentReceiptTypeViewPage,
  PaymentReceiptTypeListPage,
  PaymentReceiptTypeUpdatePage,
  PaymentReceiptUseViewPage,
  PaymentReceiptUseListPage,
  PaymentReceiptCreatePage,
  PaymentReceiptViewPage,
  PaymentReceiptListPage,
  PaymentReceiptUpdatePage,
  PaymentReceiptBatchCreatePage,
  TadManagerConfigViewPage,
  TadManagerConfigListPage,
  TadManagerConfigUpdatePage,
  DocumentGenerationParamsCreatePage,
  DocumentGenerationParamsViewPage,
  DocumentGenerationParamsListPage,
  DocumentGenerationParamsUpdatePage,
  EditionDocumentationWorkflowStateCreatePage,
  EditionDocumentationWorkflowStateViewPage,
  EditionDocumentationWorkflowStateListPage,
  EditionDocumentationWorkflowStateUpdatePage,
  SignedEditionDndaWorkflowStateCreatePage,
  SignedEditionDndaWorkflowStateViewPage,
  SignedEditionDndaWorkflowStateListPage,
  SignedEditionDndaWorkflowStateUpdatePage,
  SignedEditionSadaicWorkflowStateCreatePage,
  SignedEditionSadaicWorkflowStateViewPage,
  SignedEditionSadaicWorkflowStateListPage,
  SignedEditionSadaicWorkflowStateUpdatePage,
  LlmProviderCreatePage,
  LlmProviderViewPage,
  LlmProviderListPage,
  LlmProviderUpdatePage,
  TenantLlmConfigCreatePage,
  TenantLlmConfigViewPage,
  TenantLlmConfigListPage,
  TenantLlmConfigUpdatePage,
  TenantDocumentCreatePage,
  TenantDocumentViewPage,
  TenantDocumentListPage,
  TenantDocumentUpdatePage,
  AiSearchConversationViewPage,
  AiSearchConversationListPage,
  AiSearchResponseCreatePage,
  AiSearchResponseViewPage,
  AiSearchResponseListPage,
  AiSearchToolCallViewPage,
  AiSearchToolCallListPage,
  TenantTokenUsageViewPage,
  TenantTokenUsageListPage,
  TenantStorageUsageViewPage,
  TenantStorageUsageListPage,
  AiSearchAutoEvalViewPage,
  AiSearchAutoEvalListPage,
  AiSearchPatternCreatePage,
  AiSearchPatternViewPage,
  AiSearchPatternListPage,
  AiSearchPatternUpdatePage,
  EvaluationQueryCreatePage,
  EvaluationQueryViewPage,
  EvaluationQueryListPage,
  EvaluationQueryUpdatePage,
  QueryPatternCreatePage,
  QueryPatternViewPage,
  QueryPatternListPage,
  QueryPatternUpdatePage,
  EsignatureConfigCreatePage,
  EsignatureConfigViewPage,
  EsignatureConfigListPage,
  EsignatureConfigUpdatePage,
  EsignatureDocumentViewPage,
  EsignatureDocumentListPage,
  EsignatureRecipientViewPage,
  EsignatureRecipientListPage,
  EsignatureWebhookEventViewPage,
  EsignatureWebhookEventListPage,
} from "../entities";
import {
  IdasPage,
  OnisPage,
  CuesheetsPage,
  AutomationPage,
  SimulationPage,
} from "../pages";
import { getRootStore } from "../store/init";
import { RouterSync } from "./RouterSync";
import { RouteErrorBoundary } from "../common/components/ErrorBoundary";
import { observer } from "mobx-react";
import { Audience, currentAudience } from "../audience/audience";
import { AuthorHome } from "../audience/AuthorHome";
const GalleryRoute = React.lazy(() =>
  import("../theme/gallery/GalleryRoute").then((m) => ({
    default: m.GalleryRoute,
  }))
);
const ManualPage = React.lazy(() =>
  import("../theme/gallery/ManualPage").then((m) => ({ default: m.ManualPage }))
);

export type RouteNameType = string;

export const homePath = "/";
export const loginPath = "/login";
export const changePasswordPath = "/change-password";
export const forgotPasswordPath = "/forgot-password";
export const resetPasswordPath = "/reset-password";
export const verifyEmailPath = "/verify-email";
export const notFoundPath = "*";
export const userCreatePath = "/user/create/:duplicateFrom?";
export const userViewPath = "/user/view/:id?";
export const userListPath = "/user/list";
export const userUpdatePath = "/user/update/:id?";
export const roleCreatePath = "/role/create/:duplicateFrom?";
export const roleViewPath = "/role/view/:id?";
export const roleListPath = "/role/list";
export const roleUpdatePath = "/role/update/:id?";
export const permissionCreatePath = "/permission/create/:duplicateFrom?";
export const permissionViewPath = "/permission/view/:id?";
export const permissionListPath = "/permission/list";
export const permissionUpdatePath = "/permission/update/:id?";
export const tenantCreatePath = "/tenant/create/:duplicateFrom?";
export const tenantViewPath = "/tenant/view/:id?";
export const tenantListPath = "/tenant/list";
export const tenantUpdatePath = "/tenant/update/:id?";
export const tenantProfileCreatePath = "/tenantProfile/create/:duplicateFrom?";
export const tenantProfileViewPath = "/tenantProfile/view/:id?";
export const tenantProfileListPath = "/tenantProfile/list";
export const tenantProfileUpdatePath = "/tenantProfile/update/:id?";
export const vatStatusCreatePath = "/vatStatus/create/:duplicateFrom?";
export const vatStatusViewPath = "/vatStatus/view/:id?";
export const vatStatusListPath = "/vatStatus/list";
export const vatStatusUpdatePath = "/vatStatus/update/:id?";
export const grossReceiptsStatusCreatePath =
  "/grossReceiptsStatus/create/:duplicateFrom?";
export const grossReceiptsStatusViewPath = "/grossReceiptsStatus/view/:id?";
export const grossReceiptsStatusListPath = "/grossReceiptsStatus/list";
export const grossReceiptsStatusUpdatePath = "/grossReceiptsStatus/update/:id?";
export const tenantTypeCreatePath = "/tenantType/create/:duplicateFrom?";
export const tenantTypeViewPath = "/tenantType/view/:id?";
export const tenantTypeListPath = "/tenantType/list";
export const tenantTypeUpdatePath = "/tenantType/update/:id?";
export const tenantStatusCreatePath = "/tenantStatus/create/:duplicateFrom?";
export const tenantStatusViewPath = "/tenantStatus/view/:id?";
export const tenantStatusListPath = "/tenantStatus/list";
export const tenantStatusUpdatePath = "/tenantStatus/update/:id?";
export const currencyCreatePath = "/currency/create/:duplicateFrom?";
export const currencyViewPath = "/currency/view/:id?";
export const currencyListPath = "/currency/list";
export const currencyUpdatePath = "/currency/update/:id?";
export const tenantPlanCreatePath = "/tenantPlan/create/:duplicateFrom?";
export const tenantPlanViewPath = "/tenantPlan/view/:id?";
export const tenantPlanListPath = "/tenantPlan/list";
export const tenantPlanUpdatePath = "/tenantPlan/update/:id?";
export const countryCreatePath = "/country/create/:duplicateFrom?";
export const countryViewPath = "/country/view/:id?";
export const countryListPath = "/country/list";
export const countryUpdatePath = "/country/update/:id?";
export const provinceStateCreatePath = "/provinceState/create/:duplicateFrom?";
export const provinceStateViewPath = "/provinceState/view/:id?";
export const provinceStateListPath = "/provinceState/list";
export const provinceStateUpdatePath = "/provinceState/update/:id?";
export const creditTierCreatePath = "/creditTier/create/:duplicateFrom?";
export const creditTierViewPath = "/creditTier/view/:id?";
export const creditTierListPath = "/creditTier/list";
export const creditTierUpdatePath = "/creditTier/update/:id?";
export const creditAccountViewPath = "/creditAccount/view/:id?";
export const creditAccountListPath = "/creditAccount/list";
export const creditAccountUpdatePath = "/creditAccount/update/:id?";
export const creditPurchaseCreatePath =
  "/creditPurchase/create/:duplicateFrom?";
export const creditPurchaseViewPath = "/creditPurchase/view/:id?";
export const creditPurchaseListPath = "/creditPurchase/list";
export const creditMovementViewPath = "/creditMovement/view/:id?";
export const creditMovementListPath = "/creditMovement/list";
export const workerEventViewPath = "/workerEvent/view/:id?";
export const workerEventListPath = "/workerEvent/list";
export const simulationSessionViewPath = "/simulationSession/view/:id?";
export const simulationSessionListPath = "/simulationSession/list";
export const snapshotOverrideCreatePath =
  "/snapshotOverride/create/:duplicateFrom?";
export const snapshotOverrideViewPath = "/snapshotOverride/view/:id?";
export const snapshotOverrideListPath = "/snapshotOverride/list";
export const snapshotOverrideUpdatePath = "/snapshotOverride/update/:id?";
export const botRunViewPath = "/botRun/view/:id?";
export const botRunListPath = "/botRun/list";
export const botPhaseViewPath = "/botPhase/view/:id?";
export const botPhaseListPath = "/botPhase/list";
export const botStepViewPath = "/botStep/view/:id?";
export const botStepListPath = "/botStep/list";
export const botErrorViewPath = "/botError/view/:id?";
export const botErrorListPath = "/botError/list";
export const satelliteMachineCreatePath =
  "/satelliteMachine/create/:duplicateFrom?";
export const satelliteMachineViewPath = "/satelliteMachine/view/:id?";
export const satelliteMachineListPath = "/satelliteMachine/list";
export const satelliteMachineUpdatePath = "/satelliteMachine/update/:id?";
export const satelliteTaskViewPath = "/satelliteTask/view/:id?";
export const satelliteTaskListPath = "/satelliteTask/list";
export const satelliteHeartbeatViewPath = "/satelliteHeartbeat/view/:id?";
export const satelliteHeartbeatListPath = "/satelliteHeartbeat/list";
export const dashboardWidgetViewPath = "/dashboardWidget/view/:id?";
export const dashboardWidgetListPath = "/dashboardWidget/list";
export const tenantWidgetAccessCreatePath =
  "/tenantWidgetAccess/create/:duplicateFrom?";
export const tenantWidgetAccessViewPath = "/tenantWidgetAccess/view/:id?";
export const tenantWidgetAccessListPath = "/tenantWidgetAccess/list";
export const tenantWidgetAccessUpdatePath = "/tenantWidgetAccess/update/:id?";
export const userWidgetConfigCreatePath =
  "/userWidgetConfig/create/:duplicateFrom?";
export const userWidgetConfigViewPath = "/userWidgetConfig/view/:id?";
export const userWidgetConfigListPath = "/userWidgetConfig/list";
export const userWidgetConfigUpdatePath = "/userWidgetConfig/update/:id?";
export const dashboardLayoutTemplateCreatePath =
  "/dashboardLayoutTemplate/create/:duplicateFrom?";
export const dashboardLayoutTemplateViewPath =
  "/dashboardLayoutTemplate/view/:id?";
export const dashboardLayoutTemplateListPath = "/dashboardLayoutTemplate/list";
export const dashboardLayoutTemplateUpdatePath =
  "/dashboardLayoutTemplate/update/:id?";
export const reportCreatePath = "/report/create/:duplicateFrom?";
export const reportViewPath = "/report/view/:id?";
export const reportListPath = "/report/list";
export const reportUpdatePath = "/report/update/:id?";
export const reportTypeCreatePath = "/reportType/create/:duplicateFrom?";
export const reportTypeViewPath = "/reportType/view/:id?";
export const reportTypeListPath = "/reportType/list";
export const reportTypeUpdatePath = "/reportType/update/:id?";
export const userNotificationViewPath = "/userNotification/view/:id?";
export const userNotificationListPath = "/userNotification/list";
export const userNotificationPreferenceCreatePath =
  "/userNotificationPreference/create/:duplicateFrom?";
export const userNotificationPreferenceViewPath =
  "/userNotificationPreference/view/:id?";
export const userNotificationPreferenceListPath =
  "/userNotificationPreference/list";
export const userNotificationPreferenceUpdatePath =
  "/userNotificationPreference/update/:id?";
export const alertRuleCreatePath = "/alertRule/create/:duplicateFrom?";
export const alertRuleViewPath = "/alertRule/view/:id?";
export const alertRuleListPath = "/alertRule/list";
export const alertRuleUpdatePath = "/alertRule/update/:id?";
export const alertSubscriptionCreatePath =
  "/alertSubscription/create/:duplicateFrom?";
export const alertSubscriptionViewPath = "/alertSubscription/view/:id?";
export const alertSubscriptionListPath = "/alertSubscription/list";
export const alertSubscriptionUpdatePath = "/alertSubscription/update/:id?";
export const emailVerificationCreatePath =
  "/emailVerification/create/:duplicateFrom?";
export const emailVerificationViewPath = "/emailVerification/view/:id?";
export const emailVerificationListPath = "/emailVerification/list";
export const emailVerificationUpdatePath = "/emailVerification/update/:id?";
export const showcaseWorkflowStateCreatePath =
  "/showcaseWorkflowState/create/:duplicateFrom?";
export const showcaseWorkflowStateViewPath = "/showcaseWorkflowState/view/:id?";
export const showcaseWorkflowStateListPath = "/showcaseWorkflowState/list";
export const showcaseWorkflowStateUpdatePath =
  "/showcaseWorkflowState/update/:id?";
export const showcaseCategoryCreatePath =
  "/showcaseCategory/create/:duplicateFrom?";
export const showcaseCategoryViewPath = "/showcaseCategory/view/:id?";
export const showcaseCategoryListPath = "/showcaseCategory/list";
export const showcaseCategoryUpdatePath = "/showcaseCategory/update/:id?";
export const showcaseLineViewPath = "/showcaseLine/view/:id?";
export const showcaseLineListPath = "/showcaseLine/list";
export const designShowcaseCreatePath =
  "/designShowcase/create/:duplicateFrom?";
export const designShowcaseViewPath = "/designShowcase/view/:id?";
export const designShowcaseListPath = "/designShowcase/list";
export const designShowcaseUpdatePath = "/designShowcase/update/:id?";
export const themeViewPath = "/theme/view/:id?";
export const themeListPath = "/theme/list";
export const authorComposerCreatePath =
  "/authorComposer/create/:duplicateFrom?";
export const authorComposerViewPath = "/authorComposer/view/:id?";
export const authorComposerListPath = "/authorComposer/list";
export const authorComposerUpdatePath = "/authorComposer/update/:id?";
export const collectiveManagementSocietyCreatePath =
  "/collectiveManagementSociety/create/:duplicateFrom?";
export const collectiveManagementSocietyViewPath =
  "/collectiveManagementSociety/view/:id?";
export const collectiveManagementSocietyListPath =
  "/collectiveManagementSociety/list";
export const collectiveManagementSocietyUpdatePath =
  "/collectiveManagementSociety/update/:id?";
export const authorCollectingSocietyViewPath =
  "/authorCollectingSociety/view/:id?";
export const authorCollectingSocietyListPath = "/authorCollectingSociety/list";
export const publisherCreatePath = "/publisher/create/:duplicateFrom?";
export const publisherViewPath = "/publisher/view/:id?";
export const publisherListPath = "/publisher/list";
export const publisherUpdatePath = "/publisher/update/:id?";
export const authorPublisherViewPath = "/authorPublisher/view/:id?";
export const authorPublisherListPath = "/authorPublisher/list";
export const workAuthorPublisherViewPath = "/workAuthorPublisher/view/:id?";
export const workAuthorPublisherListPath = "/workAuthorPublisher/list";
export const publisherCollectingSocietyViewPath =
  "/publisherCollectingSociety/view/:id?";
export const publisherCollectingSocietyListPath =
  "/publisherCollectingSociety/list";
export const publisherRepresentativeViewPath =
  "/publisherRepresentative/view/:id?";
export const publisherRepresentativeListPath = "/publisherRepresentative/list";
export const editionTypeCreatePath = "/editionType/create/:duplicateFrom?";
export const editionTypeViewPath = "/editionType/view/:id?";
export const editionTypeListPath = "/editionType/list";
export const editionTypeUpdatePath = "/editionType/update/:id?";
export const musicalWorkCreatePath = "/musicalWork/create/:duplicateFrom?";
export const musicalWorkViewPath = "/musicalWork/view/:id?";
export const musicalWorkListPath = "/musicalWork/list";
export const musicalWorkUpdatePath = "/musicalWork/update/:id?";
export const phonogramViewPath = "/phonogram/view/:id?";
export const phonogramListPath = "/phonogram/list";
export const territoryCreatePath = "/territory/create/:duplicateFrom?";
export const territoryViewPath = "/territory/view/:id?";
export const territoryListPath = "/territory/list";
export const territoryUpdatePath = "/territory/update/:id?";
export const musicalWorkLinkViewPath = "/musicalWorkLink/view/:id?";
export const musicalWorkLinkListPath = "/musicalWorkLink/list";
export const platformCreatePath = "/platform/create/:duplicateFrom?";
export const platformViewPath = "/platform/view/:id?";
export const platformListPath = "/platform/list";
export const platformUpdatePath = "/platform/update/:id?";
export const platformLinkTypeCreatePath =
  "/platformLinkType/create/:duplicateFrom?";
export const platformLinkTypeViewPath = "/platformLinkType/view/:id?";
export const platformLinkTypeListPath = "/platformLinkType/list";
export const platformLinkTypeUpdatePath = "/platformLinkType/update/:id?";
export const workAuthorViewPath = "/workAuthor/view/:id?";
export const workAuthorListPath = "/workAuthor/list";
export const editionCreatePath = "/edition/create/:duplicateFrom?";
export const editionViewPath = "/edition/view/:id?";
export const editionListPath = "/edition/list";
export const editionUpdatePath = "/edition/update/:id?";
export const signedEditionViewPath = "/signedEdition/view/:id?";
export const signedEditionListPath = "/signedEdition/list";
export const editionContractPublisherViewPath =
  "/editionContractPublisher/view/:id?";
export const editionContractPublisherListPath =
  "/editionContractPublisher/list";
export const editionDocumentationViewPath = "/editionDocumentation/view/:id?";
export const editionDocumentationListPath = "/editionDocumentation/list";
export const signedContractViewPath = "/signedContract/view/:id?";
export const signedContractListPath = "/signedContract/list";
export const editionDocumentTypeCreatePath =
  "/editionDocumentType/create/:duplicateFrom?";
export const editionDocumentTypeViewPath = "/editionDocumentType/view/:id?";
export const editionDocumentTypeListPath = "/editionDocumentType/list";
export const editionDocumentTypeUpdatePath = "/editionDocumentType/update/:id?";
export const associatedDocumentEditionViewPath =
  "/associatedDocumentEdition/view/:id?";
export const associatedDocumentEditionListPath =
  "/associatedDocumentEdition/list";
export const associatedDocumentSignedEditionViewPath =
  "/associatedDocumentSignedEdition/view/:id?";
export const associatedDocumentSignedEditionListPath =
  "/associatedDocumentSignedEdition/list";
export const signedEditionBlockchainCertViewPath =
  "/signedEditionBlockchainCert/view/:id?";
export const signedEditionBlockchainCertListPath =
  "/signedEditionBlockchainCert/list";
export const userAttachmentEditionViewPath = "/userAttachmentEdition/view/:id?";
export const userAttachmentEditionListPath = "/userAttachmentEdition/list";
export const interpreterCreatePath = "/interpreter/create/:duplicateFrom?";
export const interpreterViewPath = "/interpreter/view/:id?";
export const interpreterListPath = "/interpreter/list";
export const interpreterUpdatePath = "/interpreter/update/:id?";
export const musicalGenreCreatePath = "/musicalGenre/create/:duplicateFrom?";
export const musicalGenreViewPath = "/musicalGenre/view/:id?";
export const musicalGenreListPath = "/musicalGenre/list";
export const musicalGenreUpdatePath = "/musicalGenre/update/:id?";
export const contractObservationCreatePath =
  "/contractObservation/create/:duplicateFrom?";
export const contractObservationViewPath = "/contractObservation/view/:id?";
export const contractObservationListPath = "/contractObservation/list";
export const contractObservationUpdatePath = "/contractObservation/update/:id?";
export const paymentReceiptTypeCreatePath =
  "/paymentReceiptType/create/:duplicateFrom?";
export const paymentReceiptTypeViewPath = "/paymentReceiptType/view/:id?";
export const paymentReceiptTypeListPath = "/paymentReceiptType/list";
export const paymentReceiptTypeUpdatePath = "/paymentReceiptType/update/:id?";
export const paymentReceiptUseViewPath = "/paymentReceiptUse/view/:id?";
export const paymentReceiptUseListPath = "/paymentReceiptUse/list";
export const paymentReceiptCreatePath =
  "/paymentReceipt/create/:duplicateFrom?";
export const paymentReceiptViewPath = "/paymentReceipt/view/:id?";
export const paymentReceiptListPath = "/paymentReceipt/list";
export const paymentReceiptUpdatePath = "/paymentReceipt/update/:id?";
export const tadManagerConfigViewPath = "/tadManagerConfig/view/:id?";
export const tadManagerConfigListPath = "/tadManagerConfig/list";
export const tadManagerConfigUpdatePath = "/tadManagerConfig/update/:id?";
export const documentGenerationParamsCreatePath =
  "/documentGenerationParams/create/:duplicateFrom?";
export const documentGenerationParamsViewPath =
  "/documentGenerationParams/view/:id?";
export const documentGenerationParamsListPath =
  "/documentGenerationParams/list";
export const documentGenerationParamsUpdatePath =
  "/documentGenerationParams/update/:id?";
export const editionDocumentationWorkflowStateCreatePath =
  "/editionDocumentationWorkflowState/create/:duplicateFrom?";
export const editionDocumentationWorkflowStateViewPath =
  "/editionDocumentationWorkflowState/view/:id?";
export const editionDocumentationWorkflowStateListPath =
  "/editionDocumentationWorkflowState/list";
export const editionDocumentationWorkflowStateUpdatePath =
  "/editionDocumentationWorkflowState/update/:id?";
export const signedEditionDndaWorkflowStateCreatePath =
  "/signedEditionDndaWorkflowState/create/:duplicateFrom?";
export const signedEditionDndaWorkflowStateViewPath =
  "/signedEditionDndaWorkflowState/view/:id?";
export const signedEditionDndaWorkflowStateListPath =
  "/signedEditionDndaWorkflowState/list";
export const signedEditionDndaWorkflowStateUpdatePath =
  "/signedEditionDndaWorkflowState/update/:id?";
export const signedEditionSadaicWorkflowStateCreatePath =
  "/signedEditionSadaicWorkflowState/create/:duplicateFrom?";
export const signedEditionSadaicWorkflowStateViewPath =
  "/signedEditionSadaicWorkflowState/view/:id?";
export const signedEditionSadaicWorkflowStateListPath =
  "/signedEditionSadaicWorkflowState/list";
export const signedEditionSadaicWorkflowStateUpdatePath =
  "/signedEditionSadaicWorkflowState/update/:id?";
export const llmProviderCreatePath = "/llmProvider/create/:duplicateFrom?";
export const llmProviderViewPath = "/llmProvider/view/:id?";
export const llmProviderListPath = "/llmProvider/list";
export const llmProviderUpdatePath = "/llmProvider/update/:id?";
export const tenantLlmConfigCreatePath =
  "/tenantLlmConfig/create/:duplicateFrom?";
export const tenantLlmConfigViewPath = "/tenantLlmConfig/view/:id?";
export const tenantLlmConfigListPath = "/tenantLlmConfig/list";
export const tenantLlmConfigUpdatePath = "/tenantLlmConfig/update/:id?";
export const tenantDocumentCreatePath =
  "/tenantDocument/create/:duplicateFrom?";
export const tenantDocumentViewPath = "/tenantDocument/view/:id?";
export const tenantDocumentListPath = "/tenantDocument/list";
export const tenantDocumentUpdatePath = "/tenantDocument/update/:id?";
export const aiSearchConversationViewPath = "/aiSearchConversation/view/:id?";
export const aiSearchConversationListPath = "/aiSearchConversation/list";
export const aiSearchResponseCreatePath =
  "/aiSearchResponse/create/:duplicateFrom?";
export const aiSearchResponseViewPath = "/aiSearchResponse/view/:id?";
export const aiSearchResponseListPath = "/aiSearchResponse/list";
export const aiSearchToolCallViewPath = "/aiSearchToolCall/view/:id?";
export const aiSearchToolCallListPath = "/aiSearchToolCall/list";
export const tenantTokenUsageViewPath = "/tenantTokenUsage/view/:id?";
export const tenantTokenUsageListPath = "/tenantTokenUsage/list";
export const tenantStorageUsageViewPath = "/tenantStorageUsage/view/:id?";
export const tenantStorageUsageListPath = "/tenantStorageUsage/list";
export const aiSearchAutoEvalViewPath = "/aiSearchAutoEval/view/:id?";
export const aiSearchAutoEvalListPath = "/aiSearchAutoEval/list";
export const aiSearchPatternCreatePath =
  "/aiSearchPattern/create/:duplicateFrom?";
export const aiSearchPatternViewPath = "/aiSearchPattern/view/:id?";
export const aiSearchPatternListPath = "/aiSearchPattern/list";
export const aiSearchPatternUpdatePath = "/aiSearchPattern/update/:id?";
export const evaluationQueryCreatePath =
  "/evaluationQuery/create/:duplicateFrom?";
export const evaluationQueryViewPath = "/evaluationQuery/view/:id?";
export const evaluationQueryListPath = "/evaluationQuery/list";
export const evaluationQueryUpdatePath = "/evaluationQuery/update/:id?";
export const queryPatternCreatePath = "/queryPattern/create/:duplicateFrom?";
export const queryPatternViewPath = "/queryPattern/view/:id?";
export const queryPatternListPath = "/queryPattern/list";
export const queryPatternUpdatePath = "/queryPattern/update/:id?";
export const esignatureConfigCreatePath =
  "/esignatureConfig/create/:duplicateFrom?";
export const esignatureConfigViewPath = "/esignatureConfig/view/:id?";
export const esignatureConfigListPath = "/esignatureConfig/list";
export const esignatureConfigUpdatePath = "/esignatureConfig/update/:id?";
export const esignatureDocumentViewPath = "/esignatureDocument/view/:id?";
export const esignatureDocumentListPath = "/esignatureDocument/list";
export const esignatureRecipientViewPath = "/esignatureRecipient/view/:id?";
export const esignatureRecipientListPath = "/esignatureRecipient/list";
export const esignatureWebhookEventViewPath =
  "/esignatureWebhookEvent/view/:id?";
export const esignatureWebhookEventListPath = "/esignatureWebhookEvent/list";
export const siteUserCreatePath = "/site-user/create/:duplicateFrom?";
export const siteUserViewPath = "/site-user/view/:id?";
export const siteUserListPath = "/site-user/list";
export const siteUserUpdatePath = "/site-user/update/:id?";
export const myCreditPurchasesCreatePath =
  "/my-credit-purchases/create/:duplicateFrom?";
export const myCreditPurchasesViewPath = "/my-credit-purchases/view/:id?";
export const myCreditPurchasesListPath = "/my-credit-purchases/list";
export const authorComposerPublicCreatePath =
  "/author-composer-public/create/:duplicateFrom?";
export const authorComposerPublicViewPath = "/author-composer-public/view/:id?";
export const authorComposerPublicListPath = "/author-composer-public/list";
export const authorComposerPublicUpdatePath =
  "/author-composer-public/update/:id?";

export const publicPaths: string[] = [];

async function protectedLoader({ request }: LoaderFunctionArgs) {
  const rootStore = getRootStore();
  const { authStore } = rootStore;

  if (!authStore.hasLoggedKey()) {
    const url = new URL(request.url);
    const redirectParam = `${url.pathname}${url.search}`;
    return redirect(`/login?redirect=${encodeURIComponent(redirectParam)}`);
  }

  // Wait for user data to be loaded (initialization may be in progress)
  if (authStore.status !== "logged" || !authStore.me) {
    // Poll until user is loaded or timeout
    const maxWait = 5000;
    const interval = 50;
    let waited = 0;
    while (
      (!authStore.me || authStore.status !== "logged") &&
      waited < maxWait
    ) {
      await new Promise((resolve) => setTimeout(resolve, interval));
      waited += interval;
    }

    // If still not logged after waiting, redirect to login
    if (!authStore.me) {
      const url = new URL(request.url);
      const redirectParam = `${url.pathname}${url.search}`;
      return redirect(`/login?redirect=${encodeURIComponent(redirectParam)}`);
    }
  }
  return null;
}

function createEntityLoader(_path: string, isPublic: boolean) {
  return async (args: LoaderFunctionArgs) => {
    if (!isPublic) {
      return protectedLoader(args);
    }
    return null;
  };
}

function createRoleLoader(roles: string[]) {
  return async (args: LoaderFunctionArgs) => {
    // First check authentication and wait for user data
    const authResult = await protectedLoader(args);
    if (authResult) return authResult;

    // Then check roles using unified hasPermissions
    const rootStore = getRootStore();
    const { authStore } = rootStore;

    if (!authStore.hasPermissions(null, roles)) {
      return redirect("/");
    }
    return null;
  };
}

function createAudienceLoader(
  entityAudiences: Audience[],
  inner: (
    args: LoaderFunctionArgs
  ) => Promise<Response | null> = protectedLoader
) {
  return async (args: LoaderFunctionArgs) => {
    const authResult = await inner(args);
    if (authResult) return authResult;
    if (!entityAudiences.includes(currentAudience())) {
      return redirect("/");
    }
    return null;
  };
}

// "/" de la audiencia author: su bienvenida, no el HomePage del proyecto.
const HomeRoute = observer(() =>
  currentAudience() === "author" ? <AuthorHome /> : <HomePage />
);

async function loginLoader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  const redirectUrl = url.searchParams.get("redirect") || "/";
  return { redirectUrl };
}

async function resetPasswordLoader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  const token = url.searchParams.get("token");
  return { token };
}

export const routes: RouteObject[] = [
  {
    element: <RouterSync />,
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        path: "/theme-lab",
        element: (
          <React.Suspense fallback={null}>
            <GalleryRoute />
          </React.Suspense>
        ),
        loader: createRoleLoader(["SysAdmin"]),
        handle: { title: () => "Sistema de diseno", breadcrumb: false },
      },
      {
        path: "/theme-lab/manual",
        element: (
          <React.Suspense fallback={null}>
            <ManualPage />
          </React.Suspense>
        ),
        loader: createRoleLoader(["SysAdmin"]),
        handle: {
          title: () => "Manual del sistema de diseno",
          breadcrumb: false,
        },
      },
      {
        path: "/",
        element: <HomeRoute />,
        handle: {
          title: () => getRootStore().langStore.homePathLabel,
          breadcrumb: false,
        },
      },
      {
        path: "/login",
        element: <LoginPage />,
        loader: loginLoader,
        handle: {
          title: () => getRootStore().langStore.loginPathLabel,
          breadcrumb: false,
        },
      },
      {
        path: "/change-password",
        element: <ChangePasswordPage />,
        loader: protectedLoader,
        handle: {
          title: () => getRootStore().langStore.changePasswordPathLabel,
          breadcrumb: true,
        },
      },
      {
        path: "/forgot-password",
        element: <ForgotPasswordPage />,
        handle: {
          title: () => getRootStore().langStore.forgotPasswordPathLabel,
          breadcrumb: false,
        },
      },
      {
        path: "/reset-password",
        element: <ResetPasswordPage />,
        loader: resetPasswordLoader,
        handle: {
          title: () => getRootStore().langStore.resetPasswordPathLabel,
          breadcrumb: false,
        },
      },
      {
        path: "/verify-email",
        element: <VerifyEmailPage />,
        handle: {
          title: () => "Verificar Email",
          breadcrumb: false,
        },
      },
      {
        path: "user",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.UserPlural || "User"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/user/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <UserCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.UserSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <UserViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.UserSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <UserUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.UserSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <UserListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.UserPlural || "User"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "role",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.RolePlural || "Role"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/role/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <RoleCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/role/create/:duplicateFrom?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.RoleSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <RoleViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/role/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.RoleSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <RoleUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/role/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.RoleSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <RoleListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/role/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.RolePlural || "Role"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "permission",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.PermissionPlural || "Permission"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/permission/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <PermissionCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/permission/create/:duplicateFrom?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.PermissionSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <PermissionViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/permission/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.PermissionSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <PermissionUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/permission/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.PermissionSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <PermissionListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/permission/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.PermissionPlural || "Permission"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "tenant",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.TenantPlural || "Tenant"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/tenant/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <TenantCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.TenantSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <TenantViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.TenantSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <TenantUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.TenantSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <TenantListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.TenantPlural || "Tenant"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "tenantProfile",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.TenantProfilePlural || "TenantProfile"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/tenantProfile/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <TenantProfileCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SiteAdmin", "SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.TenantProfileSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <TenantProfileViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SiteAdmin", "SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.TenantProfileSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <TenantProfileUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SiteAdmin", "SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.TenantProfileSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <TenantProfileListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SiteAdmin", "SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.TenantProfilePlural ||
                    "TenantProfile"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "vatStatus",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.VatStatusPlural || "VatStatus"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/vatStatus/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <VatStatusCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/vatStatus/create/:duplicateFrom?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.VatStatusSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <VatStatusViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/vatStatus/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.VatStatusSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <VatStatusUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/vatStatus/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.VatStatusSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <VatStatusListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/vatStatus/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.VatStatusPlural || "VatStatus"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "grossReceiptsStatus",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.GrossReceiptsStatusPlural ||
                "GrossReceiptsStatus"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/grossReceiptsStatus/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <GrossReceiptsStatusCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/grossReceiptsStatus/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.GrossReceiptsStatusSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <GrossReceiptsStatusViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/grossReceiptsStatus/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.GrossReceiptsStatusSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <GrossReceiptsStatusUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/grossReceiptsStatus/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.GrossReceiptsStatusSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <GrossReceiptsStatusListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/grossReceiptsStatus/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.GrossReceiptsStatusPlural ||
                    "GrossReceiptsStatus"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "tenantType",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.TenantTypePlural || "TenantType"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/tenantType/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <TenantTypeCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.TenantTypeSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <TenantTypeViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.TenantTypeSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <TenantTypeUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.TenantTypeSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <TenantTypeListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.TenantTypePlural || "TenantType"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "tenantStatus",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.TenantStatusPlural || "TenantStatus"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/tenantStatus/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <TenantStatusCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.TenantStatusSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <TenantStatusViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.TenantStatusSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <TenantStatusUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.TenantStatusSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <TenantStatusListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.TenantStatusPlural || "TenantStatus"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "currency",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.CurrencyPlural || "Currency"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/currency/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <CurrencyCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/currency/create/:duplicateFrom?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.CurrencySingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <CurrencyViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/currency/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.CurrencySingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <CurrencyUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/currency/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.CurrencySingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <CurrencyListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/currency/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.CurrencyPlural || "Currency"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "tenantPlan",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.TenantPlanPlural || "TenantPlan"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/tenantPlan/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <TenantPlanCreatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.TenantPlanSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <TenantPlanViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.TenantPlanSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <TenantPlanUpdatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.TenantPlanSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <TenantPlanListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.TenantPlanPlural || "TenantPlan"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "country",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.CountryPlural || "Country"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/country/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <CountryCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/country/create/:duplicateFrom?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.CountrySingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <CountryViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/country/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.CountrySingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <CountryUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/country/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.CountrySingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <CountryListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/country/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.CountryPlural || "Country"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "provinceState",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.ProvinceStatePlural || "ProvinceState"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/provinceState/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <ProvinceStateCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/provinceState/create/:duplicateFrom?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.ProvinceStateSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <ProvinceStateViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/provinceState/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.ProvinceStateSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <ProvinceStateUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/provinceState/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.ProvinceStateSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <ProvinceStateListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/provinceState/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.ProvinceStatePlural ||
                    "ProvinceState"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "creditTier",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.CreditTierPlural || "CreditTier"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/creditTier/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <CreditTierCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.CreditTierSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <CreditTierViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.CreditTierSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <CreditTierUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.CreditTierSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <CreditTierListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.CreditTierPlural || "CreditTier"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "creditAccount",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.CreditAccountPlural || "CreditAccount"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/creditAccount/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <CreditAccountViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/creditAccount/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.CreditAccountSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <CreditAccountUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/creditAccount/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.CreditAccountSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <CreditAccountListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/creditAccount/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.CreditAccountPlural ||
                    "CreditAccount"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "creditPurchase",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.CreditPurchasePlural || "CreditPurchase"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/creditPurchase/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <CreditPurchaseCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/creditPurchase/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.CreditPurchaseSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <CreditPurchaseViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/creditPurchase/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.CreditPurchaseSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <CreditPurchaseListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/creditPurchase/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.CreditPurchasePlural ||
                    "CreditPurchase"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "creditMovement",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.CreditMovementPlural || "CreditMovement"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/creditMovement/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <CreditMovementViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/creditMovement/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.CreditMovementSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <CreditMovementListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/creditMovement/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.CreditMovementPlural ||
                    "CreditMovement"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "workerEvent",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.WorkerEventPlural || "WorkerEvent"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/workerEvent/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <WorkerEventViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/workerEvent/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.WorkerEventSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <WorkerEventListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/workerEvent/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.WorkerEventPlural || "WorkerEvent"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "simulationSession",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.SimulationSessionPlural ||
                "SimulationSession"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/simulationSession/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <SimulationSessionViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/simulationSession/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.SimulationSessionSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <SimulationSessionListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/simulationSession/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.SimulationSessionPlural ||
                    "SimulationSession"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "snapshotOverride",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.SnapshotOverridePlural ||
                "SnapshotOverride"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/snapshotOverride/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <SnapshotOverrideCreatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader(
                "/snapshotOverride/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.SnapshotOverrideSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <SnapshotOverrideViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/snapshotOverride/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.SnapshotOverrideSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <SnapshotOverrideUpdatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/snapshotOverride/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.SnapshotOverrideSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <SnapshotOverrideListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/snapshotOverride/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.SnapshotOverridePlural ||
                    "SnapshotOverride"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "botRun",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.BotRunPlural || "BotRun"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/botRun/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <BotRunViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/botRun/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.BotRunSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <BotRunListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/botRun/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.BotRunPlural || "BotRun"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "botPhase",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.BotPhasePlural || "BotPhase"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/botPhase/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <BotPhaseViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/botPhase/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.BotPhaseSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <BotPhaseListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/botPhase/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.BotPhasePlural || "BotPhase"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "botStep",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.BotStepPlural || "BotStep"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/botStep/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <BotStepViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/botStep/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.BotStepSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <BotStepListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/botStep/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.BotStepPlural || "BotStep"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "botError",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.BotErrorPlural || "BotError"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/botError/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <BotErrorViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/botError/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.BotErrorSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <BotErrorListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/botError/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.BotErrorPlural || "BotError"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "satelliteMachine",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.SatelliteMachinePlural ||
                "SatelliteMachine"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/satelliteMachine/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <SatelliteMachineCreatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader(
                "/satelliteMachine/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.SatelliteMachineSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <SatelliteMachineViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/satelliteMachine/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.SatelliteMachineSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <SatelliteMachineUpdatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/satelliteMachine/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.SatelliteMachineSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <SatelliteMachineListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/satelliteMachine/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.SatelliteMachinePlural ||
                    "SatelliteMachine"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "satelliteTask",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.SatelliteTaskPlural || "SatelliteTask"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/satelliteTask/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <SatelliteTaskViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/satelliteTask/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.SatelliteTaskSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <SatelliteTaskListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/satelliteTask/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.SatelliteTaskPlural ||
                    "SatelliteTask"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "satelliteHeartbeat",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.SatelliteHeartbeatPlural ||
                "SatelliteHeartbeat"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/satelliteHeartbeat/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <SatelliteHeartbeatViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/satelliteHeartbeat/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.SatelliteHeartbeatSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <SatelliteHeartbeatListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/satelliteHeartbeat/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.SatelliteHeartbeatPlural ||
                    "SatelliteHeartbeat"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "dashboardWidget",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.DashboardWidgetPlural ||
                "DashboardWidget"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/dashboardWidget/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <DashboardWidgetViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/dashboardWidget/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.DashboardWidgetSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <DashboardWidgetListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/dashboardWidget/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.DashboardWidgetPlural ||
                    "DashboardWidget"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "tenantWidgetAccess",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.TenantWidgetAccessPlural ||
                "TenantWidgetAccess"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/tenantWidgetAccess/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <TenantWidgetAccessCreatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader(
                "/tenantWidgetAccess/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.TenantWidgetAccessSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <TenantWidgetAccessViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/tenantWidgetAccess/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.TenantWidgetAccessSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <TenantWidgetAccessUpdatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/tenantWidgetAccess/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.TenantWidgetAccessSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <TenantWidgetAccessListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/tenantWidgetAccess/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.TenantWidgetAccessPlural ||
                    "TenantWidgetAccess"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "userWidgetConfig",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.UserWidgetConfigPlural ||
                "UserWidgetConfig"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/userWidgetConfig/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <UserWidgetConfigCreatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader(
                "/userWidgetConfig/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.UserWidgetConfigSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <UserWidgetConfigViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/userWidgetConfig/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.UserWidgetConfigSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <UserWidgetConfigUpdatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/userWidgetConfig/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.UserWidgetConfigSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <UserWidgetConfigListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/userWidgetConfig/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.UserWidgetConfigPlural ||
                    "UserWidgetConfig"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "dashboardLayoutTemplate",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.DashboardLayoutTemplatePlural ||
                "DashboardLayoutTemplate"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/dashboardLayoutTemplate/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <DashboardLayoutTemplateCreatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader(
                "/dashboardLayoutTemplate/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.DashboardLayoutTemplateSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <DashboardLayoutTemplateViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/dashboardLayoutTemplate/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.DashboardLayoutTemplateSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <DashboardLayoutTemplateUpdatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/dashboardLayoutTemplate/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.DashboardLayoutTemplateSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <DashboardLayoutTemplateListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/dashboardLayoutTemplate/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.DashboardLayoutTemplatePlural ||
                    "DashboardLayoutTemplate"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "report",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.ReportPlural || "Report"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/report/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <ReportCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/report/create/:duplicateFrom?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.ReportSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <ReportViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/report/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.ReportSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <ReportUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/report/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.ReportSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <ReportListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/report/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.ReportPlural || "Report"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "reportType",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.ReportTypePlural || "ReportType"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/reportType/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <ReportTypeCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/reportType/create/:duplicateFrom?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.ReportTypeSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <ReportTypeViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/reportType/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.ReportTypeSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <ReportTypeUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/reportType/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.ReportTypeSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <ReportTypeListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/reportType/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.ReportTypePlural || "ReportType"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "userNotification",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.UserNotificationPlural ||
                "UserNotification"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/userNotification/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <UserNotificationViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/userNotification/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.UserNotificationSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <UserNotificationListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/userNotification/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.UserNotificationPlural ||
                    "UserNotification"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "userNotificationPreference",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.UserNotificationPreferencePlural ||
                "UserNotificationPreference"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/userNotificationPreference/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <UserNotificationPreferenceCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/userNotificationPreference/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.UserNotificationPreferenceSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <UserNotificationPreferenceViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/userNotificationPreference/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.UserNotificationPreferenceSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <UserNotificationPreferenceUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/userNotificationPreference/update/:id?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.UserNotificationPreferenceSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <UserNotificationPreferenceListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/userNotificationPreference/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.UserNotificationPreferencePlural ||
                    "UserNotificationPreference"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "alertRule",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.AlertRulePlural || "AlertRule"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/alertRule/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <AlertRuleCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin", "SiteAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.AlertRuleSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <AlertRuleViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin", "SiteAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.AlertRuleSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <AlertRuleUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin", "SiteAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.AlertRuleSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <AlertRuleListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin", "SiteAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.AlertRulePlural || "AlertRule"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "alertSubscription",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.AlertSubscriptionPlural ||
                "AlertSubscription"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/alertSubscription/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <AlertSubscriptionCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/alertSubscription/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.AlertSubscriptionSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <AlertSubscriptionViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/alertSubscription/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.AlertSubscriptionSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <AlertSubscriptionUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/alertSubscription/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.AlertSubscriptionSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <AlertSubscriptionListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/alertSubscription/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.AlertSubscriptionPlural ||
                    "AlertSubscription"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "emailVerification",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.EmailVerificationPlural ||
                "EmailVerification"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/emailVerification/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <EmailVerificationCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/emailVerification/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.EmailVerificationSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <EmailVerificationViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/emailVerification/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.EmailVerificationSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <EmailVerificationUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/emailVerification/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.EmailVerificationSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <EmailVerificationListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/emailVerification/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.EmailVerificationPlural ||
                    "EmailVerification"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "showcaseWorkflowState",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.ShowcaseWorkflowStatePlural ||
                "ShowcaseWorkflowState"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/showcaseWorkflowState/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <ShowcaseWorkflowStateCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/showcaseWorkflowState/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.ShowcaseWorkflowStateSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <ShowcaseWorkflowStateViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/showcaseWorkflowState/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.ShowcaseWorkflowStateSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <ShowcaseWorkflowStateUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/showcaseWorkflowState/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.ShowcaseWorkflowStateSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <ShowcaseWorkflowStateListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/showcaseWorkflowState/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.ShowcaseWorkflowStatePlural ||
                    "ShowcaseWorkflowState"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "showcaseCategory",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.ShowcaseCategoryPlural ||
                "ShowcaseCategory"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/showcaseCategory/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <ShowcaseCategoryCreatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader(
                "/showcaseCategory/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.ShowcaseCategorySingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <ShowcaseCategoryViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/showcaseCategory/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.ShowcaseCategorySingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <ShowcaseCategoryUpdatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/showcaseCategory/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.ShowcaseCategorySingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <ShowcaseCategoryListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/showcaseCategory/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.ShowcaseCategoryPlural ||
                    "ShowcaseCategory"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "showcaseLine",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.ShowcaseLinePlural || "ShowcaseLine"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/showcaseLine/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <ShowcaseLineViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/showcaseLine/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.ShowcaseLineSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <ShowcaseLineListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/showcaseLine/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.ShowcaseLinePlural || "ShowcaseLine"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "designShowcase",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.DesignShowcasePlural || "DesignShowcase"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/designShowcase/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <DesignShowcaseCreatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader(
                "/designShowcase/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.DesignShowcaseSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <DesignShowcaseViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/designShowcase/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.DesignShowcaseSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <DesignShowcaseUpdatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/designShowcase/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.DesignShowcaseSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <DesignShowcaseListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/designShowcase/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.DesignShowcasePlural ||
                    "DesignShowcase"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "theme",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.ThemePlural || "Theme"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/theme/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <ThemeViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.ThemeSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <ThemeListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.ThemePlural || "Theme"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "authorComposer",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.AuthorComposerPlural || "AuthorComposer"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/authorComposer/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <AuthorComposerCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/authorComposer/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.AuthorComposerSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <AuthorComposerViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/authorComposer/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.AuthorComposerSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <AuthorComposerUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/authorComposer/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.AuthorComposerSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <AuthorComposerListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/authorComposer/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.AuthorComposerPlural ||
                    "AuthorComposer"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "collectiveManagementSociety",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.CollectiveManagementSocietyPlural ||
                "CollectiveManagementSociety"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/collectiveManagementSociety/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <CollectiveManagementSocietyCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/collectiveManagementSociety/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.CollectiveManagementSocietySingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <CollectiveManagementSocietyViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/collectiveManagementSociety/view/:id?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.CollectiveManagementSocietySingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <CollectiveManagementSocietyUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/collectiveManagementSociety/update/:id?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.CollectiveManagementSocietySingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <CollectiveManagementSocietyListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/collectiveManagementSociety/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.CollectiveManagementSocietyPlural ||
                    "CollectiveManagementSociety"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "authorCollectingSociety",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.AuthorCollectingSocietyPlural ||
                "AuthorCollectingSociety"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/authorCollectingSociety/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <AuthorCollectingSocietyViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/authorCollectingSociety/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.AuthorCollectingSocietySingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <AuthorCollectingSocietyListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/authorCollectingSociety/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.AuthorCollectingSocietyPlural ||
                    "AuthorCollectingSociety"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "publisher",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.PublisherPlural || "Publisher"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/publisher/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <PublisherCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/publisher/create/:duplicateFrom?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.PublisherSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <PublisherViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/publisher/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.PublisherSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <PublisherUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/publisher/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.PublisherSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <PublisherListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/publisher/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.PublisherPlural || "Publisher"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "authorPublisher",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.AuthorPublisherPlural ||
                "AuthorPublisher"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/authorPublisher/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <AuthorPublisherViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/authorPublisher/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.AuthorPublisherSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <AuthorPublisherListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/authorPublisher/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.AuthorPublisherPlural ||
                    "AuthorPublisher"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "workAuthorPublisher",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.WorkAuthorPublisherPlural ||
                "WorkAuthorPublisher"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/workAuthorPublisher/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <WorkAuthorPublisherViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/workAuthorPublisher/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.WorkAuthorPublisherSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <WorkAuthorPublisherListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/workAuthorPublisher/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.WorkAuthorPublisherPlural ||
                    "WorkAuthorPublisher"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "publisherCollectingSociety",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.PublisherCollectingSocietyPlural ||
                "PublisherCollectingSociety"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/publisherCollectingSociety/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <PublisherCollectingSocietyViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/publisherCollectingSociety/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.PublisherCollectingSocietySingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <PublisherCollectingSocietyListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/publisherCollectingSociety/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.PublisherCollectingSocietyPlural ||
                    "PublisherCollectingSociety"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "publisherRepresentative",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.PublisherRepresentativePlural ||
                "PublisherRepresentative"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/publisherRepresentative/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <PublisherRepresentativeViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/publisherRepresentative/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.PublisherRepresentativeSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <PublisherRepresentativeListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/publisherRepresentative/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.PublisherRepresentativePlural ||
                    "PublisherRepresentative"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "editionType",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.EditionTypePlural || "EditionType"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/editionType/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <EditionTypeCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/editionType/create/:duplicateFrom?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.EditionTypeSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <EditionTypeViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/editionType/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.EditionTypeSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <EditionTypeUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/editionType/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.EditionTypeSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <EditionTypeListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/editionType/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.EditionTypePlural || "EditionType"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "musicalWork",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.MusicalWorkPlural || "MusicalWork"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/musicalWork/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <MusicalWorkCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/musicalWork/create/:duplicateFrom?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.MusicalWorkSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <MusicalWorkViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/musicalWork/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.MusicalWorkSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <MusicalWorkUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/musicalWork/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.MusicalWorkSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <MusicalWorkListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/musicalWork/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.MusicalWorkPlural || "MusicalWork"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "phonogram",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.PhonogramPlural || "Phonogram"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/phonogram/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <PhonogramViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/phonogram/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.PhonogramSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <PhonogramListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/phonogram/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.PhonogramPlural || "Phonogram"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "territory",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.TerritoryPlural || "Territory"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/territory/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <TerritoryCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/territory/create/:duplicateFrom?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.TerritorySingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <TerritoryViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/territory/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.TerritorySingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <TerritoryUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/territory/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.TerritorySingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <TerritoryListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/territory/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.TerritoryPlural || "Territory"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "musicalWorkLink",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.MusicalWorkLinkPlural ||
                "MusicalWorkLink"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/musicalWorkLink/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <MusicalWorkLinkViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/musicalWorkLink/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.MusicalWorkLinkSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <MusicalWorkLinkListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/musicalWorkLink/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.MusicalWorkLinkPlural ||
                    "MusicalWorkLink"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "platform",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.PlatformPlural || "Platform"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/platform/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <PlatformCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/platform/create/:duplicateFrom?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.PlatformSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <PlatformViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/platform/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.PlatformSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <PlatformUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/platform/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.PlatformSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <PlatformListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/platform/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.PlatformPlural || "Platform"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "platformLinkType",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.PlatformLinkTypePlural ||
                "PlatformLinkType"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/platformLinkType/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <PlatformLinkTypeCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/platformLinkType/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.PlatformLinkTypeSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <PlatformLinkTypeViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/platformLinkType/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.PlatformLinkTypeSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <PlatformLinkTypeUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/platformLinkType/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.PlatformLinkTypeSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <PlatformLinkTypeListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/platformLinkType/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.PlatformLinkTypePlural ||
                    "PlatformLinkType"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "workAuthor",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.WorkAuthorPlural || "WorkAuthor"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/workAuthor/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <WorkAuthorViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/workAuthor/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.WorkAuthorSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <WorkAuthorListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/workAuthor/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.WorkAuthorPlural || "WorkAuthor"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "edition",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.EditionPlural || "Edition"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/edition/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <EditionCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/edition/create/:duplicateFrom?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.EditionSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <EditionViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/edition/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.EditionSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <EditionUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/edition/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.EditionSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <EditionListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/edition/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.EditionPlural || "Edition"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "signedEdition",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.SignedEditionPlural || "SignedEdition"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/signedEdition/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <SignedEditionViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/signedEdition/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.SignedEditionSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <SignedEditionListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/signedEdition/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.SignedEditionPlural ||
                    "SignedEdition"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "editionContractPublisher",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.EditionContractPublisherPlural ||
                "EditionContractPublisher"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/editionContractPublisher/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <EditionContractPublisherViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/editionContractPublisher/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.EditionContractPublisherSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <EditionContractPublisherListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/editionContractPublisher/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.EditionContractPublisherPlural ||
                    "EditionContractPublisher"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "editionDocumentation",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.EditionDocumentationPlural ||
                "EditionDocumentation"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/editionDocumentation/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <EditionDocumentationViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/editionDocumentation/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.EditionDocumentationSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <EditionDocumentationListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/editionDocumentation/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.EditionDocumentationPlural ||
                    "EditionDocumentation"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "signedContract",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.SignedContractPlural || "SignedContract"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/signedContract/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <SignedContractViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/signedContract/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.SignedContractSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <SignedContractListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/signedContract/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.SignedContractPlural ||
                    "SignedContract"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "editionDocumentType",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.EditionDocumentTypePlural ||
                "EditionDocumentType"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/editionDocumentType/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <EditionDocumentTypeCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/editionDocumentType/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.EditionDocumentTypeSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <EditionDocumentTypeViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/editionDocumentType/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.EditionDocumentTypeSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <EditionDocumentTypeUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/editionDocumentType/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.EditionDocumentTypeSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <EditionDocumentTypeListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/editionDocumentType/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.EditionDocumentTypePlural ||
                    "EditionDocumentType"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "associatedDocumentEdition",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.AssociatedDocumentEditionPlural ||
                "AssociatedDocumentEdition"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/associatedDocumentEdition/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <AssociatedDocumentEditionViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/associatedDocumentEdition/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.AssociatedDocumentEditionSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <AssociatedDocumentEditionListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/associatedDocumentEdition/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.AssociatedDocumentEditionPlural ||
                    "AssociatedDocumentEdition"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "associatedDocumentSignedEdition",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.AssociatedDocumentSignedEditionPlural ||
                "AssociatedDocumentSignedEdition"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/associatedDocumentSignedEdition/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <AssociatedDocumentSignedEditionViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/associatedDocumentSignedEdition/view/:id?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore
                    .AssociatedDocumentSignedEditionSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <AssociatedDocumentSignedEditionListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/associatedDocumentSignedEdition/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore
                    .AssociatedDocumentSignedEditionPlural ||
                    "AssociatedDocumentSignedEdition"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "signedEditionBlockchainCert",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.SignedEditionBlockchainCertPlural ||
                "SignedEditionBlockchainCert"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/signedEditionBlockchainCert/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <SignedEditionBlockchainCertViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/signedEditionBlockchainCert/view/:id?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.SignedEditionBlockchainCertSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <SignedEditionBlockchainCertListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/signedEditionBlockchainCert/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.SignedEditionBlockchainCertPlural ||
                    "SignedEditionBlockchainCert"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "userAttachmentEdition",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.UserAttachmentEditionPlural ||
                "UserAttachmentEdition"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/userAttachmentEdition/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <UserAttachmentEditionViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/userAttachmentEdition/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.UserAttachmentEditionSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <UserAttachmentEditionListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/userAttachmentEdition/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.UserAttachmentEditionPlural ||
                    "UserAttachmentEdition"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "interpreter",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.InterpreterPlural || "Interpreter"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/interpreter/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <InterpreterCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/interpreter/create/:duplicateFrom?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.InterpreterSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <InterpreterViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/interpreter/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.InterpreterSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <InterpreterUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/interpreter/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.InterpreterSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <InterpreterListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/interpreter/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.InterpreterPlural || "Interpreter"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "musicalGenre",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.MusicalGenrePlural || "MusicalGenre"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/musicalGenre/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <MusicalGenreCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/musicalGenre/create/:duplicateFrom?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.MusicalGenreSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <MusicalGenreViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/musicalGenre/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.MusicalGenreSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <MusicalGenreUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/musicalGenre/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.MusicalGenreSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <MusicalGenreListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/musicalGenre/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.MusicalGenrePlural || "MusicalGenre"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "contractObservation",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.ContractObservationPlural ||
                "ContractObservation"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/contractObservation/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <ContractObservationCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/contractObservation/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.ContractObservationSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <ContractObservationViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/contractObservation/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.ContractObservationSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <ContractObservationUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/contractObservation/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.ContractObservationSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <ContractObservationListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/contractObservation/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.ContractObservationPlural ||
                    "ContractObservation"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "paymentReceiptType",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.PaymentReceiptTypePlural ||
                "PaymentReceiptType"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/paymentReceiptType/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <PaymentReceiptTypeCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/paymentReceiptType/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.PaymentReceiptTypeSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <PaymentReceiptTypeViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/paymentReceiptType/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.PaymentReceiptTypeSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <PaymentReceiptTypeUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/paymentReceiptType/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.PaymentReceiptTypeSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <PaymentReceiptTypeListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/paymentReceiptType/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.PaymentReceiptTypePlural ||
                    "PaymentReceiptType"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "paymentReceiptUse",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.PaymentReceiptUsePlural ||
                "PaymentReceiptUse"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/paymentReceiptUse/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <PaymentReceiptUseViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/paymentReceiptUse/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.PaymentReceiptUseSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <PaymentReceiptUseListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/paymentReceiptUse/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.PaymentReceiptUsePlural ||
                    "PaymentReceiptUse"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "paymentReceipt",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.PaymentReceiptPlural || "PaymentReceipt"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/paymentReceipt/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <PaymentReceiptCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/paymentReceipt/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.PaymentReceiptSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "batch-create",
            element: <PaymentReceiptBatchCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/paymentReceipt/batch-create", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.batchCreateCommand} ${
                  getRootStore().langStore.PaymentReceiptSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <PaymentReceiptViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/paymentReceipt/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.PaymentReceiptSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <PaymentReceiptUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/paymentReceipt/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.PaymentReceiptSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <PaymentReceiptListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/paymentReceipt/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.PaymentReceiptPlural ||
                    "PaymentReceipt"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "tadManagerConfig",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.TadManagerConfigPlural ||
                "TadManagerConfig"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/tadManagerConfig/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <TadManagerConfigViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.TadManagerConfigSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <TadManagerConfigUpdatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.TadManagerConfigSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <TadManagerConfigListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.TadManagerConfigPlural ||
                    "TadManagerConfig"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "documentGenerationParams",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.DocumentGenerationParamsPlural ||
                "DocumentGenerationParams"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/documentGenerationParams/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <DocumentGenerationParamsCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/documentGenerationParams/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.DocumentGenerationParamsSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <DocumentGenerationParamsViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/documentGenerationParams/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.DocumentGenerationParamsSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <DocumentGenerationParamsUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/documentGenerationParams/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.DocumentGenerationParamsSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <DocumentGenerationParamsListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/documentGenerationParams/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.DocumentGenerationParamsPlural ||
                    "DocumentGenerationParams"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "editionDocumentationWorkflowState",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore
                .EditionDocumentationWorkflowStatePlural ||
                "EditionDocumentationWorkflowState"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/editionDocumentationWorkflowState/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <EditionDocumentationWorkflowStateCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/editionDocumentationWorkflowState/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore
                    .EditionDocumentationWorkflowStateSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <EditionDocumentationWorkflowStateViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/editionDocumentationWorkflowState/view/:id?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore
                    .EditionDocumentationWorkflowStateSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <EditionDocumentationWorkflowStateUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/editionDocumentationWorkflowState/update/:id?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore
                    .EditionDocumentationWorkflowStateSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <EditionDocumentationWorkflowStateListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/editionDocumentationWorkflowState/list",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore
                    .EditionDocumentationWorkflowStatePlural ||
                    "EditionDocumentationWorkflowState"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "signedEditionDndaWorkflowState",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.SignedEditionDndaWorkflowStatePlural ||
                "SignedEditionDndaWorkflowState"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/signedEditionDndaWorkflowState/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <SignedEditionDndaWorkflowStateCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/signedEditionDndaWorkflowState/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore
                    .SignedEditionDndaWorkflowStateSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <SignedEditionDndaWorkflowStateViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/signedEditionDndaWorkflowState/view/:id?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore
                    .SignedEditionDndaWorkflowStateSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <SignedEditionDndaWorkflowStateUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/signedEditionDndaWorkflowState/update/:id?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore
                    .SignedEditionDndaWorkflowStateSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <SignedEditionDndaWorkflowStateListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/signedEditionDndaWorkflowState/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore
                    .SignedEditionDndaWorkflowStatePlural ||
                    "SignedEditionDndaWorkflowState"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "signedEditionSadaicWorkflowState",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.SignedEditionSadaicWorkflowStatePlural ||
                "SignedEditionSadaicWorkflowState"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/signedEditionSadaicWorkflowState/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <SignedEditionSadaicWorkflowStateCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/signedEditionSadaicWorkflowState/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore
                    .SignedEditionSadaicWorkflowStateSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <SignedEditionSadaicWorkflowStateViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/signedEditionSadaicWorkflowState/view/:id?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore
                    .SignedEditionSadaicWorkflowStateSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <SignedEditionSadaicWorkflowStateUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/signedEditionSadaicWorkflowState/update/:id?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore
                    .SignedEditionSadaicWorkflowStateSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <SignedEditionSadaicWorkflowStateListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/signedEditionSadaicWorkflowState/list",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore
                    .SignedEditionSadaicWorkflowStatePlural ||
                    "SignedEditionSadaicWorkflowState"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "llmProvider",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.LlmProviderPlural || "LlmProvider"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/llmProvider/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <LlmProviderCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/llmProvider/create/:duplicateFrom?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.LlmProviderSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <LlmProviderViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/llmProvider/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.LlmProviderSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <LlmProviderUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/llmProvider/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.LlmProviderSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <LlmProviderListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/llmProvider/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.LlmProviderPlural || "LlmProvider"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "tenantLlmConfig",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.TenantLlmConfigPlural ||
                "TenantLlmConfig"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/tenantLlmConfig/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <TenantLlmConfigCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/tenantLlmConfig/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.TenantLlmConfigSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <TenantLlmConfigViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/tenantLlmConfig/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.TenantLlmConfigSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <TenantLlmConfigUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/tenantLlmConfig/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.TenantLlmConfigSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <TenantLlmConfigListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/tenantLlmConfig/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.TenantLlmConfigPlural ||
                    "TenantLlmConfig"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "tenantDocument",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.TenantDocumentPlural || "TenantDocument"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/tenantDocument/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <TenantDocumentCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/tenantDocument/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.TenantDocumentSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <TenantDocumentViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/tenantDocument/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.TenantDocumentSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <TenantDocumentUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/tenantDocument/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.TenantDocumentSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <TenantDocumentListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/tenantDocument/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.TenantDocumentPlural ||
                    "TenantDocument"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "aiSearchConversation",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.AiSearchConversationPlural ||
                "AiSearchConversation"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/aiSearchConversation/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <AiSearchConversationViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/aiSearchConversation/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.AiSearchConversationSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <AiSearchConversationListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/aiSearchConversation/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.AiSearchConversationPlural ||
                    "AiSearchConversation"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "aiSearchResponse",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.AiSearchResponsePlural ||
                "AiSearchResponse"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/aiSearchResponse/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <AiSearchResponseCreatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader(
                "/aiSearchResponse/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.AiSearchResponseSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <AiSearchResponseViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/aiSearchResponse/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.AiSearchResponseSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <AiSearchResponseListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/aiSearchResponse/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.AiSearchResponsePlural ||
                    "AiSearchResponse"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "aiSearchToolCall",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.AiSearchToolCallPlural ||
                "AiSearchToolCall"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/aiSearchToolCall/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <AiSearchToolCallViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/aiSearchToolCall/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.AiSearchToolCallSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <AiSearchToolCallListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/aiSearchToolCall/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.AiSearchToolCallPlural ||
                    "AiSearchToolCall"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "tenantTokenUsage",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.TenantTokenUsagePlural ||
                "TenantTokenUsage"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/tenantTokenUsage/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <TenantTokenUsageViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/tenantTokenUsage/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.TenantTokenUsageSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <TenantTokenUsageListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/tenantTokenUsage/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.TenantTokenUsagePlural ||
                    "TenantTokenUsage"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "tenantStorageUsage",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.TenantStorageUsagePlural ||
                "TenantStorageUsage"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/tenantStorageUsage/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <TenantStorageUsageViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/tenantStorageUsage/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.TenantStorageUsageSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <TenantStorageUsageListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/tenantStorageUsage/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.TenantStorageUsagePlural ||
                    "TenantStorageUsage"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "aiSearchAutoEval",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.AiSearchAutoEvalPlural ||
                "AiSearchAutoEval"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/aiSearchAutoEval/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <AiSearchAutoEvalViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/aiSearchAutoEval/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.AiSearchAutoEvalSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <AiSearchAutoEvalListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/aiSearchAutoEval/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.AiSearchAutoEvalPlural ||
                    "AiSearchAutoEval"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "aiSearchPattern",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.AiSearchPatternPlural ||
                "AiSearchPattern"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/aiSearchPattern/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <AiSearchPatternCreatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader(
                "/aiSearchPattern/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.AiSearchPatternSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <AiSearchPatternViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/aiSearchPattern/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.AiSearchPatternSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <AiSearchPatternUpdatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/aiSearchPattern/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.AiSearchPatternSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <AiSearchPatternListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createEntityLoader("/aiSearchPattern/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.AiSearchPatternPlural ||
                    "AiSearchPattern"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "evaluationQuery",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.EvaluationQueryPlural ||
                "EvaluationQuery"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/evaluationQuery/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <EvaluationQueryCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader(
                "/evaluationQuery/create/:duplicateFrom?",
                false
              )
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.EvaluationQuerySingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <EvaluationQueryViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/evaluationQuery/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.EvaluationQuerySingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <EvaluationQueryUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/evaluationQuery/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.EvaluationQuerySingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <EvaluationQueryListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/evaluationQuery/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.EvaluationQueryPlural ||
                    "EvaluationQuery"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "queryPattern",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.QueryPatternPlural || "QueryPattern"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/queryPattern/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <QueryPatternCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/queryPattern/create/:duplicateFrom?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.QueryPatternSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <QueryPatternViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/queryPattern/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.QueryPatternSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <QueryPatternUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/queryPattern/update/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.QueryPatternSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <QueryPatternListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/queryPattern/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.QueryPatternPlural || "QueryPattern"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "esignatureConfig",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.EsignatureConfigPlural ||
                "EsignatureConfig"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/esignatureConfig/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <EsignatureConfigCreatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.EsignatureConfigSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <EsignatureConfigViewPage />,
            loader: createAudienceLoader(
              ["platform"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.EsignatureConfigSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <EsignatureConfigUpdatePage />,
            loader: createAudienceLoader(
              ["platform"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.EsignatureConfigSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <EsignatureConfigListPage />,
            loader: createAudienceLoader(
              ["platform"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.EsignatureConfigPlural ||
                    "EsignatureConfig"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "esignatureDocument",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.EsignatureDocumentPlural ||
                "EsignatureDocument"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/esignatureDocument/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <EsignatureDocumentViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/esignatureDocument/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.EsignatureDocumentSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <EsignatureDocumentListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/esignatureDocument/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.EsignatureDocumentPlural ||
                    "EsignatureDocument"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "esignatureRecipient",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.EsignatureRecipientPlural ||
                "EsignatureRecipient"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/esignatureRecipient/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <EsignatureRecipientViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/esignatureRecipient/view/:id?", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.EsignatureRecipientSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <EsignatureRecipientListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createEntityLoader("/esignatureRecipient/list", false)
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.EsignatureRecipientPlural ||
                    "EsignatureRecipient"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "esignatureWebhookEvent",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.EsignatureWebhookEventPlural ||
                "EsignatureWebhookEvent"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/esignatureWebhookEvent/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <EsignatureWebhookEventViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.EsignatureWebhookEventSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <EsignatureWebhookEventListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SysAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.EsignatureWebhookEventPlural ||
                    "EsignatureWebhookEvent"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "site-user",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.UserPlural || "User"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/site-user/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <SiteUserCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SiteAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.UserSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <SiteUserViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SiteAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.UserSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <SiteUserUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SiteAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.UserSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <SiteUserListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SiteAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.UserPlural || "User"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "my-credit-purchases",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.CreditPurchasePlural || "CreditPurchase"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/my-credit-purchases/list",
        },
        children: [
          {
            path: "view/:id?",
            element: <MyCreditPurchasesViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SiteAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.CreditPurchaseSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <MyCreditPurchasesListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader(["SiteAdmin"])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.CreditPurchasePlural ||
                    "CreditPurchase"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "author-composer-public",
        handle: {
          title: () =>
            `${getRootStore().langStore.listFormTitle(
              getRootStore().langStore.AuthorComposerPlural || "AuthorComposer"
            )}`,
          breadcrumb: true,
          breadcrumbPath: "/author-composer-public/list",
        },
        children: [
          {
            path: "create/:duplicateFrom?",
            element: <AuthorComposerPublicCreatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader([])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.addCommand} ${
                  getRootStore().langStore.AuthorComposerSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "view/:id?",
            element: <AuthorComposerPublicViewPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader([])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.viewCommand} ${
                  getRootStore().langStore.AuthorComposerSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "update/:id?",
            element: <AuthorComposerPublicUpdatePage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader([])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.editCommand} ${
                  getRootStore().langStore.AuthorComposerSingular
                }`,
              breadcrumb: true,
            },
          },
          {
            path: "list",
            element: <AuthorComposerPublicListPage />,
            loader: createAudienceLoader(
              ["platform", "publisher"],
              createRoleLoader([])
            ),
            handle: {
              title: () =>
                `${getRootStore().langStore.listFormTitle(
                  getRootStore().langStore.AuthorComposerPlural ||
                    "AuthorComposer"
                )}`,
              breadcrumb: true,
            },
          },
        ],
      },
      {
        path: "/idas",
        element: <IdasPage />,
        loader: createAudienceLoader(
          ["platform", "publisher"],
          protectedLoader
        ),
        handle: {
          title: () => "IdasPage",
          breadcrumb: true,
        },
      },
      {
        path: "/onis",
        element: <OnisPage />,
        loader: createAudienceLoader(
          ["platform", "publisher"],
          protectedLoader
        ),
        handle: {
          title: () => "OnisPage",
          breadcrumb: true,
        },
      },
      {
        path: "/cuesheets",
        element: <CuesheetsPage />,
        loader: createAudienceLoader(
          ["platform", "publisher"],
          protectedLoader
        ),
        handle: {
          title: () => "CuesheetsPage",
          breadcrumb: true,
        },
      },
      {
        path: "/automation",
        element: <AutomationPage />,
        loader: createAudienceLoader(
          ["platform"],
          createRoleLoader(["SysAdmin"])
        ),
        handle: {
          title: () => "AutomationPage",
          breadcrumb: true,
        },
      },
      {
        path: "/simulation",
        element: <SimulationPage />,
        loader: createAudienceLoader(
          ["platform"],
          createRoleLoader(["SysAdmin"])
        ),
        handle: {
          title: () => "SimulationPage",
          breadcrumb: true,
        },
      },
      {
        path: "*",
        element: <NotFoundPage />,
        handle: {
          title: () => getRootStore().langStore.pageNotFoundPathLabel,
          breadcrumb: false,
        },
      },
    ],
  },
];

export function createAppRouter() {
  return createBrowserRouter(routes);
}

export const routePathMap: Record<string, { path: string }> = {
  "/": { path: "/" },
  "/login": { path: "/login" },
  "/change-password": { path: "/change-password" },
  "/forgot-password": { path: "/forgot-password" },
  "/reset-password": { path: "/reset-password" },
  "/verify-email": { path: "/verify-email" },
  "not-found": { path: "*" },
  "/user/create/:duplicateFrom?": { path: "/user/create/:duplicateFrom?" },
  "/user/view/:id?": { path: "/user/view/:id?" },
  "/user/update/:id?": { path: "/user/update/:id?" },
  "/user/list": { path: "/user/list" },
  "/role/create/:duplicateFrom?": { path: "/role/create/:duplicateFrom?" },
  "/role/view/:id?": { path: "/role/view/:id?" },
  "/role/update/:id?": { path: "/role/update/:id?" },
  "/role/list": { path: "/role/list" },
  "/permission/create/:duplicateFrom?": {
    path: "/permission/create/:duplicateFrom?",
  },
  "/permission/view/:id?": { path: "/permission/view/:id?" },
  "/permission/update/:id?": { path: "/permission/update/:id?" },
  "/permission/list": { path: "/permission/list" },
  "/tenant/create/:duplicateFrom?": { path: "/tenant/create/:duplicateFrom?" },
  "/tenant/view/:id?": { path: "/tenant/view/:id?" },
  "/tenant/update/:id?": { path: "/tenant/update/:id?" },
  "/tenant/list": { path: "/tenant/list" },
  "/tenantProfile/create/:duplicateFrom?": {
    path: "/tenantProfile/create/:duplicateFrom?",
  },
  "/tenantProfile/view/:id?": { path: "/tenantProfile/view/:id?" },
  "/tenantProfile/update/:id?": { path: "/tenantProfile/update/:id?" },
  "/tenantProfile/list": { path: "/tenantProfile/list" },
  "/vatStatus/create/:duplicateFrom?": {
    path: "/vatStatus/create/:duplicateFrom?",
  },
  "/vatStatus/view/:id?": { path: "/vatStatus/view/:id?" },
  "/vatStatus/update/:id?": { path: "/vatStatus/update/:id?" },
  "/vatStatus/list": { path: "/vatStatus/list" },
  "/grossReceiptsStatus/create/:duplicateFrom?": {
    path: "/grossReceiptsStatus/create/:duplicateFrom?",
  },
  "/grossReceiptsStatus/view/:id?": { path: "/grossReceiptsStatus/view/:id?" },
  "/grossReceiptsStatus/update/:id?": {
    path: "/grossReceiptsStatus/update/:id?",
  },
  "/grossReceiptsStatus/list": { path: "/grossReceiptsStatus/list" },
  "/tenantType/create/:duplicateFrom?": {
    path: "/tenantType/create/:duplicateFrom?",
  },
  "/tenantType/view/:id?": { path: "/tenantType/view/:id?" },
  "/tenantType/update/:id?": { path: "/tenantType/update/:id?" },
  "/tenantType/list": { path: "/tenantType/list" },
  "/tenantStatus/create/:duplicateFrom?": {
    path: "/tenantStatus/create/:duplicateFrom?",
  },
  "/tenantStatus/view/:id?": { path: "/tenantStatus/view/:id?" },
  "/tenantStatus/update/:id?": { path: "/tenantStatus/update/:id?" },
  "/tenantStatus/list": { path: "/tenantStatus/list" },
  "/currency/create/:duplicateFrom?": {
    path: "/currency/create/:duplicateFrom?",
  },
  "/currency/view/:id?": { path: "/currency/view/:id?" },
  "/currency/update/:id?": { path: "/currency/update/:id?" },
  "/currency/list": { path: "/currency/list" },
  "/tenantPlan/create/:duplicateFrom?": {
    path: "/tenantPlan/create/:duplicateFrom?",
  },
  "/tenantPlan/view/:id?": { path: "/tenantPlan/view/:id?" },
  "/tenantPlan/update/:id?": { path: "/tenantPlan/update/:id?" },
  "/tenantPlan/list": { path: "/tenantPlan/list" },
  "/country/create/:duplicateFrom?": {
    path: "/country/create/:duplicateFrom?",
  },
  "/country/view/:id?": { path: "/country/view/:id?" },
  "/country/update/:id?": { path: "/country/update/:id?" },
  "/country/list": { path: "/country/list" },
  "/provinceState/create/:duplicateFrom?": {
    path: "/provinceState/create/:duplicateFrom?",
  },
  "/provinceState/view/:id?": { path: "/provinceState/view/:id?" },
  "/provinceState/update/:id?": { path: "/provinceState/update/:id?" },
  "/provinceState/list": { path: "/provinceState/list" },
  "/creditTier/create/:duplicateFrom?": {
    path: "/creditTier/create/:duplicateFrom?",
  },
  "/creditTier/view/:id?": { path: "/creditTier/view/:id?" },
  "/creditTier/update/:id?": { path: "/creditTier/update/:id?" },
  "/creditTier/list": { path: "/creditTier/list" },
  "/creditAccount/view/:id?": { path: "/creditAccount/view/:id?" },
  "/creditAccount/update/:id?": { path: "/creditAccount/update/:id?" },
  "/creditAccount/list": { path: "/creditAccount/list" },
  "/creditPurchase/create/:duplicateFrom?": {
    path: "/creditPurchase/create/:duplicateFrom?",
  },
  "/creditPurchase/view/:id?": { path: "/creditPurchase/view/:id?" },
  "/creditPurchase/list": { path: "/creditPurchase/list" },
  "/creditMovement/view/:id?": { path: "/creditMovement/view/:id?" },
  "/creditMovement/list": { path: "/creditMovement/list" },
  "/workerEvent/view/:id?": { path: "/workerEvent/view/:id?" },
  "/workerEvent/list": { path: "/workerEvent/list" },
  "/simulationSession/view/:id?": { path: "/simulationSession/view/:id?" },
  "/simulationSession/list": { path: "/simulationSession/list" },
  "/snapshotOverride/create/:duplicateFrom?": {
    path: "/snapshotOverride/create/:duplicateFrom?",
  },
  "/snapshotOverride/view/:id?": { path: "/snapshotOverride/view/:id?" },
  "/snapshotOverride/update/:id?": { path: "/snapshotOverride/update/:id?" },
  "/snapshotOverride/list": { path: "/snapshotOverride/list" },
  "/botRun/view/:id?": { path: "/botRun/view/:id?" },
  "/botRun/list": { path: "/botRun/list" },
  "/botPhase/view/:id?": { path: "/botPhase/view/:id?" },
  "/botPhase/list": { path: "/botPhase/list" },
  "/botStep/view/:id?": { path: "/botStep/view/:id?" },
  "/botStep/list": { path: "/botStep/list" },
  "/botError/view/:id?": { path: "/botError/view/:id?" },
  "/botError/list": { path: "/botError/list" },
  "/satelliteMachine/create/:duplicateFrom?": {
    path: "/satelliteMachine/create/:duplicateFrom?",
  },
  "/satelliteMachine/view/:id?": { path: "/satelliteMachine/view/:id?" },
  "/satelliteMachine/update/:id?": { path: "/satelliteMachine/update/:id?" },
  "/satelliteMachine/list": { path: "/satelliteMachine/list" },
  "/satelliteTask/view/:id?": { path: "/satelliteTask/view/:id?" },
  "/satelliteTask/list": { path: "/satelliteTask/list" },
  "/satelliteHeartbeat/view/:id?": { path: "/satelliteHeartbeat/view/:id?" },
  "/satelliteHeartbeat/list": { path: "/satelliteHeartbeat/list" },
  "/dashboardWidget/view/:id?": { path: "/dashboardWidget/view/:id?" },
  "/dashboardWidget/list": { path: "/dashboardWidget/list" },
  "/tenantWidgetAccess/create/:duplicateFrom?": {
    path: "/tenantWidgetAccess/create/:duplicateFrom?",
  },
  "/tenantWidgetAccess/view/:id?": { path: "/tenantWidgetAccess/view/:id?" },
  "/tenantWidgetAccess/update/:id?": {
    path: "/tenantWidgetAccess/update/:id?",
  },
  "/tenantWidgetAccess/list": { path: "/tenantWidgetAccess/list" },
  "/userWidgetConfig/create/:duplicateFrom?": {
    path: "/userWidgetConfig/create/:duplicateFrom?",
  },
  "/userWidgetConfig/view/:id?": { path: "/userWidgetConfig/view/:id?" },
  "/userWidgetConfig/update/:id?": { path: "/userWidgetConfig/update/:id?" },
  "/userWidgetConfig/list": { path: "/userWidgetConfig/list" },
  "/dashboardLayoutTemplate/create/:duplicateFrom?": {
    path: "/dashboardLayoutTemplate/create/:duplicateFrom?",
  },
  "/dashboardLayoutTemplate/view/:id?": {
    path: "/dashboardLayoutTemplate/view/:id?",
  },
  "/dashboardLayoutTemplate/update/:id?": {
    path: "/dashboardLayoutTemplate/update/:id?",
  },
  "/dashboardLayoutTemplate/list": { path: "/dashboardLayoutTemplate/list" },
  "/report/create/:duplicateFrom?": { path: "/report/create/:duplicateFrom?" },
  "/report/view/:id?": { path: "/report/view/:id?" },
  "/report/update/:id?": { path: "/report/update/:id?" },
  "/report/list": { path: "/report/list" },
  "/reportType/create/:duplicateFrom?": {
    path: "/reportType/create/:duplicateFrom?",
  },
  "/reportType/view/:id?": { path: "/reportType/view/:id?" },
  "/reportType/update/:id?": { path: "/reportType/update/:id?" },
  "/reportType/list": { path: "/reportType/list" },
  "/userNotification/view/:id?": { path: "/userNotification/view/:id?" },
  "/userNotification/list": { path: "/userNotification/list" },
  "/userNotificationPreference/create/:duplicateFrom?": {
    path: "/userNotificationPreference/create/:duplicateFrom?",
  },
  "/userNotificationPreference/view/:id?": {
    path: "/userNotificationPreference/view/:id?",
  },
  "/userNotificationPreference/update/:id?": {
    path: "/userNotificationPreference/update/:id?",
  },
  "/userNotificationPreference/list": {
    path: "/userNotificationPreference/list",
  },
  "/alertRule/create/:duplicateFrom?": {
    path: "/alertRule/create/:duplicateFrom?",
  },
  "/alertRule/view/:id?": { path: "/alertRule/view/:id?" },
  "/alertRule/update/:id?": { path: "/alertRule/update/:id?" },
  "/alertRule/list": { path: "/alertRule/list" },
  "/alertSubscription/create/:duplicateFrom?": {
    path: "/alertSubscription/create/:duplicateFrom?",
  },
  "/alertSubscription/view/:id?": { path: "/alertSubscription/view/:id?" },
  "/alertSubscription/update/:id?": { path: "/alertSubscription/update/:id?" },
  "/alertSubscription/list": { path: "/alertSubscription/list" },
  "/emailVerification/create/:duplicateFrom?": {
    path: "/emailVerification/create/:duplicateFrom?",
  },
  "/emailVerification/view/:id?": { path: "/emailVerification/view/:id?" },
  "/emailVerification/update/:id?": { path: "/emailVerification/update/:id?" },
  "/emailVerification/list": { path: "/emailVerification/list" },
  "/showcaseWorkflowState/create/:duplicateFrom?": {
    path: "/showcaseWorkflowState/create/:duplicateFrom?",
  },
  "/showcaseWorkflowState/view/:id?": {
    path: "/showcaseWorkflowState/view/:id?",
  },
  "/showcaseWorkflowState/update/:id?": {
    path: "/showcaseWorkflowState/update/:id?",
  },
  "/showcaseWorkflowState/list": { path: "/showcaseWorkflowState/list" },
  "/showcaseCategory/create/:duplicateFrom?": {
    path: "/showcaseCategory/create/:duplicateFrom?",
  },
  "/showcaseCategory/view/:id?": { path: "/showcaseCategory/view/:id?" },
  "/showcaseCategory/update/:id?": { path: "/showcaseCategory/update/:id?" },
  "/showcaseCategory/list": { path: "/showcaseCategory/list" },
  "/showcaseLine/view/:id?": { path: "/showcaseLine/view/:id?" },
  "/showcaseLine/list": { path: "/showcaseLine/list" },
  "/designShowcase/create/:duplicateFrom?": {
    path: "/designShowcase/create/:duplicateFrom?",
  },
  "/designShowcase/view/:id?": { path: "/designShowcase/view/:id?" },
  "/designShowcase/update/:id?": { path: "/designShowcase/update/:id?" },
  "/designShowcase/list": { path: "/designShowcase/list" },
  "/theme/view/:id?": { path: "/theme/view/:id?" },
  "/theme/list": { path: "/theme/list" },
  "/authorComposer/create/:duplicateFrom?": {
    path: "/authorComposer/create/:duplicateFrom?",
  },
  "/authorComposer/view/:id?": { path: "/authorComposer/view/:id?" },
  "/authorComposer/update/:id?": { path: "/authorComposer/update/:id?" },
  "/authorComposer/list": { path: "/authorComposer/list" },
  "/collectiveManagementSociety/create/:duplicateFrom?": {
    path: "/collectiveManagementSociety/create/:duplicateFrom?",
  },
  "/collectiveManagementSociety/view/:id?": {
    path: "/collectiveManagementSociety/view/:id?",
  },
  "/collectiveManagementSociety/update/:id?": {
    path: "/collectiveManagementSociety/update/:id?",
  },
  "/collectiveManagementSociety/list": {
    path: "/collectiveManagementSociety/list",
  },
  "/authorCollectingSociety/view/:id?": {
    path: "/authorCollectingSociety/view/:id?",
  },
  "/authorCollectingSociety/list": { path: "/authorCollectingSociety/list" },
  "/publisher/create/:duplicateFrom?": {
    path: "/publisher/create/:duplicateFrom?",
  },
  "/publisher/view/:id?": { path: "/publisher/view/:id?" },
  "/publisher/update/:id?": { path: "/publisher/update/:id?" },
  "/publisher/list": { path: "/publisher/list" },
  "/authorPublisher/view/:id?": { path: "/authorPublisher/view/:id?" },
  "/authorPublisher/list": { path: "/authorPublisher/list" },
  "/workAuthorPublisher/view/:id?": { path: "/workAuthorPublisher/view/:id?" },
  "/workAuthorPublisher/list": { path: "/workAuthorPublisher/list" },
  "/publisherCollectingSociety/view/:id?": {
    path: "/publisherCollectingSociety/view/:id?",
  },
  "/publisherCollectingSociety/list": {
    path: "/publisherCollectingSociety/list",
  },
  "/publisherRepresentative/view/:id?": {
    path: "/publisherRepresentative/view/:id?",
  },
  "/publisherRepresentative/list": { path: "/publisherRepresentative/list" },
  "/editionType/create/:duplicateFrom?": {
    path: "/editionType/create/:duplicateFrom?",
  },
  "/editionType/view/:id?": { path: "/editionType/view/:id?" },
  "/editionType/update/:id?": { path: "/editionType/update/:id?" },
  "/editionType/list": { path: "/editionType/list" },
  "/musicalWork/create/:duplicateFrom?": {
    path: "/musicalWork/create/:duplicateFrom?",
  },
  "/musicalWork/view/:id?": { path: "/musicalWork/view/:id?" },
  "/musicalWork/update/:id?": { path: "/musicalWork/update/:id?" },
  "/musicalWork/list": { path: "/musicalWork/list" },
  "/phonogram/view/:id?": { path: "/phonogram/view/:id?" },
  "/phonogram/list": { path: "/phonogram/list" },
  "/territory/create/:duplicateFrom?": {
    path: "/territory/create/:duplicateFrom?",
  },
  "/territory/view/:id?": { path: "/territory/view/:id?" },
  "/territory/update/:id?": { path: "/territory/update/:id?" },
  "/territory/list": { path: "/territory/list" },
  "/musicalWorkLink/view/:id?": { path: "/musicalWorkLink/view/:id?" },
  "/musicalWorkLink/list": { path: "/musicalWorkLink/list" },
  "/platform/create/:duplicateFrom?": {
    path: "/platform/create/:duplicateFrom?",
  },
  "/platform/view/:id?": { path: "/platform/view/:id?" },
  "/platform/update/:id?": { path: "/platform/update/:id?" },
  "/platform/list": { path: "/platform/list" },
  "/platformLinkType/create/:duplicateFrom?": {
    path: "/platformLinkType/create/:duplicateFrom?",
  },
  "/platformLinkType/view/:id?": { path: "/platformLinkType/view/:id?" },
  "/platformLinkType/update/:id?": { path: "/platformLinkType/update/:id?" },
  "/platformLinkType/list": { path: "/platformLinkType/list" },
  "/workAuthor/view/:id?": { path: "/workAuthor/view/:id?" },
  "/workAuthor/list": { path: "/workAuthor/list" },
  "/edition/create/:duplicateFrom?": {
    path: "/edition/create/:duplicateFrom?",
  },
  "/edition/view/:id?": { path: "/edition/view/:id?" },
  "/edition/update/:id?": { path: "/edition/update/:id?" },
  "/edition/list": { path: "/edition/list" },
  "/signedEdition/view/:id?": { path: "/signedEdition/view/:id?" },
  "/signedEdition/list": { path: "/signedEdition/list" },
  "/editionContractPublisher/view/:id?": {
    path: "/editionContractPublisher/view/:id?",
  },
  "/editionContractPublisher/list": { path: "/editionContractPublisher/list" },
  "/editionDocumentation/view/:id?": {
    path: "/editionDocumentation/view/:id?",
  },
  "/editionDocumentation/list": { path: "/editionDocumentation/list" },
  "/signedContract/view/:id?": { path: "/signedContract/view/:id?" },
  "/signedContract/list": { path: "/signedContract/list" },
  "/editionDocumentType/create/:duplicateFrom?": {
    path: "/editionDocumentType/create/:duplicateFrom?",
  },
  "/editionDocumentType/view/:id?": { path: "/editionDocumentType/view/:id?" },
  "/editionDocumentType/update/:id?": {
    path: "/editionDocumentType/update/:id?",
  },
  "/editionDocumentType/list": { path: "/editionDocumentType/list" },
  "/associatedDocumentEdition/view/:id?": {
    path: "/associatedDocumentEdition/view/:id?",
  },
  "/associatedDocumentEdition/list": {
    path: "/associatedDocumentEdition/list",
  },
  "/associatedDocumentSignedEdition/view/:id?": {
    path: "/associatedDocumentSignedEdition/view/:id?",
  },
  "/associatedDocumentSignedEdition/list": {
    path: "/associatedDocumentSignedEdition/list",
  },
  "/signedEditionBlockchainCert/view/:id?": {
    path: "/signedEditionBlockchainCert/view/:id?",
  },
  "/signedEditionBlockchainCert/list": {
    path: "/signedEditionBlockchainCert/list",
  },
  "/userAttachmentEdition/view/:id?": {
    path: "/userAttachmentEdition/view/:id?",
  },
  "/userAttachmentEdition/list": { path: "/userAttachmentEdition/list" },
  "/interpreter/create/:duplicateFrom?": {
    path: "/interpreter/create/:duplicateFrom?",
  },
  "/interpreter/view/:id?": { path: "/interpreter/view/:id?" },
  "/interpreter/update/:id?": { path: "/interpreter/update/:id?" },
  "/interpreter/list": { path: "/interpreter/list" },
  "/musicalGenre/create/:duplicateFrom?": {
    path: "/musicalGenre/create/:duplicateFrom?",
  },
  "/musicalGenre/view/:id?": { path: "/musicalGenre/view/:id?" },
  "/musicalGenre/update/:id?": { path: "/musicalGenre/update/:id?" },
  "/musicalGenre/list": { path: "/musicalGenre/list" },
  "/contractObservation/create/:duplicateFrom?": {
    path: "/contractObservation/create/:duplicateFrom?",
  },
  "/contractObservation/view/:id?": { path: "/contractObservation/view/:id?" },
  "/contractObservation/update/:id?": {
    path: "/contractObservation/update/:id?",
  },
  "/contractObservation/list": { path: "/contractObservation/list" },
  "/paymentReceiptType/create/:duplicateFrom?": {
    path: "/paymentReceiptType/create/:duplicateFrom?",
  },
  "/paymentReceiptType/view/:id?": { path: "/paymentReceiptType/view/:id?" },
  "/paymentReceiptType/update/:id?": {
    path: "/paymentReceiptType/update/:id?",
  },
  "/paymentReceiptType/list": { path: "/paymentReceiptType/list" },
  "/paymentReceiptUse/view/:id?": { path: "/paymentReceiptUse/view/:id?" },
  "/paymentReceiptUse/list": { path: "/paymentReceiptUse/list" },
  "/paymentReceipt/create/:duplicateFrom?": {
    path: "/paymentReceipt/create/:duplicateFrom?",
  },
  "/paymentReceipt/batch-create": { path: "/paymentReceipt/batch-create" },
  "/paymentReceipt/view/:id?": { path: "/paymentReceipt/view/:id?" },
  "/paymentReceipt/update/:id?": { path: "/paymentReceipt/update/:id?" },
  "/paymentReceipt/list": { path: "/paymentReceipt/list" },
  "/tadManagerConfig/view/:id?": { path: "/tadManagerConfig/view/:id?" },
  "/tadManagerConfig/update/:id?": { path: "/tadManagerConfig/update/:id?" },
  "/tadManagerConfig/list": { path: "/tadManagerConfig/list" },
  "/documentGenerationParams/create/:duplicateFrom?": {
    path: "/documentGenerationParams/create/:duplicateFrom?",
  },
  "/documentGenerationParams/view/:id?": {
    path: "/documentGenerationParams/view/:id?",
  },
  "/documentGenerationParams/update/:id?": {
    path: "/documentGenerationParams/update/:id?",
  },
  "/documentGenerationParams/list": { path: "/documentGenerationParams/list" },
  "/editionDocumentationWorkflowState/create/:duplicateFrom?": {
    path: "/editionDocumentationWorkflowState/create/:duplicateFrom?",
  },
  "/editionDocumentationWorkflowState/view/:id?": {
    path: "/editionDocumentationWorkflowState/view/:id?",
  },
  "/editionDocumentationWorkflowState/update/:id?": {
    path: "/editionDocumentationWorkflowState/update/:id?",
  },
  "/editionDocumentationWorkflowState/list": {
    path: "/editionDocumentationWorkflowState/list",
  },
  "/signedEditionDndaWorkflowState/create/:duplicateFrom?": {
    path: "/signedEditionDndaWorkflowState/create/:duplicateFrom?",
  },
  "/signedEditionDndaWorkflowState/view/:id?": {
    path: "/signedEditionDndaWorkflowState/view/:id?",
  },
  "/signedEditionDndaWorkflowState/update/:id?": {
    path: "/signedEditionDndaWorkflowState/update/:id?",
  },
  "/signedEditionDndaWorkflowState/list": {
    path: "/signedEditionDndaWorkflowState/list",
  },
  "/signedEditionSadaicWorkflowState/create/:duplicateFrom?": {
    path: "/signedEditionSadaicWorkflowState/create/:duplicateFrom?",
  },
  "/signedEditionSadaicWorkflowState/view/:id?": {
    path: "/signedEditionSadaicWorkflowState/view/:id?",
  },
  "/signedEditionSadaicWorkflowState/update/:id?": {
    path: "/signedEditionSadaicWorkflowState/update/:id?",
  },
  "/signedEditionSadaicWorkflowState/list": {
    path: "/signedEditionSadaicWorkflowState/list",
  },
  "/llmProvider/create/:duplicateFrom?": {
    path: "/llmProvider/create/:duplicateFrom?",
  },
  "/llmProvider/view/:id?": { path: "/llmProvider/view/:id?" },
  "/llmProvider/update/:id?": { path: "/llmProvider/update/:id?" },
  "/llmProvider/list": { path: "/llmProvider/list" },
  "/tenantLlmConfig/create/:duplicateFrom?": {
    path: "/tenantLlmConfig/create/:duplicateFrom?",
  },
  "/tenantLlmConfig/view/:id?": { path: "/tenantLlmConfig/view/:id?" },
  "/tenantLlmConfig/update/:id?": { path: "/tenantLlmConfig/update/:id?" },
  "/tenantLlmConfig/list": { path: "/tenantLlmConfig/list" },
  "/tenantDocument/create/:duplicateFrom?": {
    path: "/tenantDocument/create/:duplicateFrom?",
  },
  "/tenantDocument/view/:id?": { path: "/tenantDocument/view/:id?" },
  "/tenantDocument/update/:id?": { path: "/tenantDocument/update/:id?" },
  "/tenantDocument/list": { path: "/tenantDocument/list" },
  "/aiSearchConversation/view/:id?": {
    path: "/aiSearchConversation/view/:id?",
  },
  "/aiSearchConversation/list": { path: "/aiSearchConversation/list" },
  "/aiSearchResponse/create/:duplicateFrom?": {
    path: "/aiSearchResponse/create/:duplicateFrom?",
  },
  "/aiSearchResponse/view/:id?": { path: "/aiSearchResponse/view/:id?" },
  "/aiSearchResponse/list": { path: "/aiSearchResponse/list" },
  "/aiSearchToolCall/view/:id?": { path: "/aiSearchToolCall/view/:id?" },
  "/aiSearchToolCall/list": { path: "/aiSearchToolCall/list" },
  "/tenantTokenUsage/view/:id?": { path: "/tenantTokenUsage/view/:id?" },
  "/tenantTokenUsage/list": { path: "/tenantTokenUsage/list" },
  "/tenantStorageUsage/view/:id?": { path: "/tenantStorageUsage/view/:id?" },
  "/tenantStorageUsage/list": { path: "/tenantStorageUsage/list" },
  "/aiSearchAutoEval/view/:id?": { path: "/aiSearchAutoEval/view/:id?" },
  "/aiSearchAutoEval/list": { path: "/aiSearchAutoEval/list" },
  "/aiSearchPattern/create/:duplicateFrom?": {
    path: "/aiSearchPattern/create/:duplicateFrom?",
  },
  "/aiSearchPattern/view/:id?": { path: "/aiSearchPattern/view/:id?" },
  "/aiSearchPattern/update/:id?": { path: "/aiSearchPattern/update/:id?" },
  "/aiSearchPattern/list": { path: "/aiSearchPattern/list" },
  "/evaluationQuery/create/:duplicateFrom?": {
    path: "/evaluationQuery/create/:duplicateFrom?",
  },
  "/evaluationQuery/view/:id?": { path: "/evaluationQuery/view/:id?" },
  "/evaluationQuery/update/:id?": { path: "/evaluationQuery/update/:id?" },
  "/evaluationQuery/list": { path: "/evaluationQuery/list" },
  "/queryPattern/create/:duplicateFrom?": {
    path: "/queryPattern/create/:duplicateFrom?",
  },
  "/queryPattern/view/:id?": { path: "/queryPattern/view/:id?" },
  "/queryPattern/update/:id?": { path: "/queryPattern/update/:id?" },
  "/queryPattern/list": { path: "/queryPattern/list" },
  "/esignatureConfig/create/:duplicateFrom?": {
    path: "/esignatureConfig/create/:duplicateFrom?",
  },
  "/esignatureConfig/view/:id?": { path: "/esignatureConfig/view/:id?" },
  "/esignatureConfig/update/:id?": { path: "/esignatureConfig/update/:id?" },
  "/esignatureConfig/list": { path: "/esignatureConfig/list" },
  "/esignatureDocument/view/:id?": { path: "/esignatureDocument/view/:id?" },
  "/esignatureDocument/list": { path: "/esignatureDocument/list" },
  "/esignatureRecipient/view/:id?": { path: "/esignatureRecipient/view/:id?" },
  "/esignatureRecipient/list": { path: "/esignatureRecipient/list" },
  "/esignatureWebhookEvent/view/:id?": {
    path: "/esignatureWebhookEvent/view/:id?",
  },
  "/esignatureWebhookEvent/list": { path: "/esignatureWebhookEvent/list" },
  "/site-user/create/:duplicateFrom?": {
    path: "/site-user/create/:duplicateFrom?",
  },
  "/site-user/view/:id?": { path: "/site-user/view/:id?" },
  "/site-user/update/:id?": { path: "/site-user/update/:id?" },
  "/site-user/list": { path: "/site-user/list" },
  "/my-credit-purchases/view/:id?": { path: "/my-credit-purchases/view/:id?" },
  "/my-credit-purchases/list": { path: "/my-credit-purchases/list" },
  "/author-composer-public/create/:duplicateFrom?": {
    path: "/author-composer-public/create/:duplicateFrom?",
  },
  "/author-composer-public/view/:id?": {
    path: "/author-composer-public/view/:id?",
  },
  "/author-composer-public/update/:id?": {
    path: "/author-composer-public/update/:id?",
  },
  "/author-composer-public/list": { path: "/author-composer-public/list" },
  "/idas": { path: "/idas" },
  "/onis": { path: "/onis" },
  "/cuesheets": { path: "/cuesheets" },
  "/automation": { path: "/automation" },
  "/simulation": { path: "/simulation" },
};
